// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: screener.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import {
  Exchange,
  exchangeFromJSON,
  exchangeToJSON,
  NotificationChannel,
  notificationChannelFromJSON,
  notificationChannelToJSON,
  SortBy,
} from "./common";
import { Empty } from "./google/protobuf/empty";
import { StringValue } from "./google/protobuf/wrappers";
import { GetScreenerWatchlistItemsRequest, UserScreenerLayout } from "./user-preference";
import { Watchlist, WatchlistItems } from "./watchlist";

export const protobufPackage = "com.tick2trade.api.screener";

export enum Operator {
  OPERATOR_UNKNOWN = 0,
  GREATER_THAN = 1,
  GREATER_THAN_EQUAL_TO = 2,
  LESS_THAN = 3,
  LESS_THAN_EQUAL_TO = 4,
  /** NOT_EQUAL_TO - key exists */
  NOT_EQUAL_TO = 5,
  IN = 6,
  EQUAL_TO = 7,
  BETWEEN = 8,
  NOT_IN = 9,
  MATCH = 10,
  OUTSIDE = 12,
  EXACT_MATCH = 13,
  UNRECOGNIZED = -1,
}

export function operatorFromJSON(object: any): Operator {
  switch (object) {
    case 0:
    case "OPERATOR_UNKNOWN":
      return Operator.OPERATOR_UNKNOWN;
    case 1:
    case "GREATER_THAN":
      return Operator.GREATER_THAN;
    case 2:
    case "GREATER_THAN_EQUAL_TO":
      return Operator.GREATER_THAN_EQUAL_TO;
    case 3:
    case "LESS_THAN":
      return Operator.LESS_THAN;
    case 4:
    case "LESS_THAN_EQUAL_TO":
      return Operator.LESS_THAN_EQUAL_TO;
    case 5:
    case "NOT_EQUAL_TO":
      return Operator.NOT_EQUAL_TO;
    case 6:
    case "IN":
      return Operator.IN;
    case 7:
    case "EQUAL_TO":
      return Operator.EQUAL_TO;
    case 8:
    case "BETWEEN":
      return Operator.BETWEEN;
    case 9:
    case "NOT_IN":
      return Operator.NOT_IN;
    case 10:
    case "MATCH":
      return Operator.MATCH;
    case 12:
    case "OUTSIDE":
      return Operator.OUTSIDE;
    case 13:
    case "EXACT_MATCH":
      return Operator.EXACT_MATCH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Operator.UNRECOGNIZED;
  }
}

export function operatorToJSON(object: Operator): string {
  switch (object) {
    case Operator.OPERATOR_UNKNOWN:
      return "OPERATOR_UNKNOWN";
    case Operator.GREATER_THAN:
      return "GREATER_THAN";
    case Operator.GREATER_THAN_EQUAL_TO:
      return "GREATER_THAN_EQUAL_TO";
    case Operator.LESS_THAN:
      return "LESS_THAN";
    case Operator.LESS_THAN_EQUAL_TO:
      return "LESS_THAN_EQUAL_TO";
    case Operator.NOT_EQUAL_TO:
      return "NOT_EQUAL_TO";
    case Operator.IN:
      return "IN";
    case Operator.EQUAL_TO:
      return "EQUAL_TO";
    case Operator.BETWEEN:
      return "BETWEEN";
    case Operator.NOT_IN:
      return "NOT_IN";
    case Operator.MATCH:
      return "MATCH";
    case Operator.OUTSIDE:
      return "OUTSIDE";
    case Operator.EXACT_MATCH:
      return "EXACT_MATCH";
    case Operator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FieldParameterType {
  TIME_BUCKET = 0,
  SOURCE = 1,
  INDICATOR_INPUT = 2,
  INDICATOR_OUTPUT = 3,
  PERIOD_OFFSET = 4,
  COMPARISON_PERIOD = 5,
  UNRECOGNIZED = -1,
}

export function fieldParameterTypeFromJSON(object: any): FieldParameterType {
  switch (object) {
    case 0:
    case "TIME_BUCKET":
      return FieldParameterType.TIME_BUCKET;
    case 1:
    case "SOURCE":
      return FieldParameterType.SOURCE;
    case 2:
    case "INDICATOR_INPUT":
      return FieldParameterType.INDICATOR_INPUT;
    case 3:
    case "INDICATOR_OUTPUT":
      return FieldParameterType.INDICATOR_OUTPUT;
    case 4:
    case "PERIOD_OFFSET":
      return FieldParameterType.PERIOD_OFFSET;
    case 5:
    case "COMPARISON_PERIOD":
      return FieldParameterType.COMPARISON_PERIOD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldParameterType.UNRECOGNIZED;
  }
}

export function fieldParameterTypeToJSON(object: FieldParameterType): string {
  switch (object) {
    case FieldParameterType.TIME_BUCKET:
      return "TIME_BUCKET";
    case FieldParameterType.SOURCE:
      return "SOURCE";
    case FieldParameterType.INDICATOR_INPUT:
      return "INDICATOR_INPUT";
    case FieldParameterType.INDICATOR_OUTPUT:
      return "INDICATOR_OUTPUT";
    case FieldParameterType.PERIOD_OFFSET:
      return "PERIOD_OFFSET";
    case FieldParameterType.COMPARISON_PERIOD:
      return "COMPARISON_PERIOD";
    case FieldParameterType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MultiplierType {
  PERCENTAGE = 0,
  TIMES = 1,
  UNRECOGNIZED = -1,
}

export function multiplierTypeFromJSON(object: any): MultiplierType {
  switch (object) {
    case 0:
    case "PERCENTAGE":
      return MultiplierType.PERCENTAGE;
    case 1:
    case "TIMES":
      return MultiplierType.TIMES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MultiplierType.UNRECOGNIZED;
  }
}

export function multiplierTypeToJSON(object: MultiplierType): string {
  switch (object) {
    case MultiplierType.PERCENTAGE:
      return "PERCENTAGE";
    case MultiplierType.TIMES:
      return "TIMES";
    case MultiplierType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DataType {
  DATA_TYPE_UNKNOWN = 0,
  BOOLEAN = 1,
  STRING = 2,
  LONG = 3,
  DOUBLE = 4,
  BIGDECIMAL = 5,
  LIST = 6,
  INTEGER = 7,
  /** DATE - Decide */
  DATE = 8,
  UNRECOGNIZED = -1,
}

export function dataTypeFromJSON(object: any): DataType {
  switch (object) {
    case 0:
    case "DATA_TYPE_UNKNOWN":
      return DataType.DATA_TYPE_UNKNOWN;
    case 1:
    case "BOOLEAN":
      return DataType.BOOLEAN;
    case 2:
    case "STRING":
      return DataType.STRING;
    case 3:
    case "LONG":
      return DataType.LONG;
    case 4:
    case "DOUBLE":
      return DataType.DOUBLE;
    case 5:
    case "BIGDECIMAL":
      return DataType.BIGDECIMAL;
    case 6:
    case "LIST":
      return DataType.LIST;
    case 7:
    case "INTEGER":
      return DataType.INTEGER;
    case 8:
    case "DATE":
      return DataType.DATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataType.UNRECOGNIZED;
  }
}

export function dataTypeToJSON(object: DataType): string {
  switch (object) {
    case DataType.DATA_TYPE_UNKNOWN:
      return "DATA_TYPE_UNKNOWN";
    case DataType.BOOLEAN:
      return "BOOLEAN";
    case DataType.STRING:
      return "STRING";
    case DataType.LONG:
      return "LONG";
    case DataType.DOUBLE:
      return "DOUBLE";
    case DataType.BIGDECIMAL:
      return "BIGDECIMAL";
    case DataType.LIST:
      return "LIST";
    case DataType.INTEGER:
      return "INTEGER";
    case DataType.DATE:
      return "DATE";
    case DataType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FilterType {
  FILTER_TYPE_UNKNOWN = 0,
  VALUE = 1,
  CHECKBOX = 2,
  SELECT = 3,
  MULTI_SELECT = 4,
  RANGE = 5,
  SEARCH = 6,
  UNRECOGNIZED = -1,
}

export function filterTypeFromJSON(object: any): FilterType {
  switch (object) {
    case 0:
    case "FILTER_TYPE_UNKNOWN":
      return FilterType.FILTER_TYPE_UNKNOWN;
    case 1:
    case "VALUE":
      return FilterType.VALUE;
    case 2:
    case "CHECKBOX":
      return FilterType.CHECKBOX;
    case 3:
    case "SELECT":
      return FilterType.SELECT;
    case 4:
    case "MULTI_SELECT":
      return FilterType.MULTI_SELECT;
    case 5:
    case "RANGE":
      return FilterType.RANGE;
    case 6:
    case "SEARCH":
      return FilterType.SEARCH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FilterType.UNRECOGNIZED;
  }
}

export function filterTypeToJSON(object: FilterType): string {
  switch (object) {
    case FilterType.FILTER_TYPE_UNKNOWN:
      return "FILTER_TYPE_UNKNOWN";
    case FilterType.VALUE:
      return "VALUE";
    case FilterType.CHECKBOX:
      return "CHECKBOX";
    case FilterType.SELECT:
      return "SELECT";
    case FilterType.MULTI_SELECT:
      return "MULTI_SELECT";
    case FilterType.RANGE:
      return "RANGE";
    case FilterType.SEARCH:
      return "SEARCH";
    case FilterType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FilterCategory {
  FILTER_CATEGORY_UNKNOWN = 0,
  ALL = 1,
  DESCRIPTIVE = 2,
  FINANCIALS = 3,
  TECHNICALS = 4,
  UNRECOGNIZED = -1,
}

export function filterCategoryFromJSON(object: any): FilterCategory {
  switch (object) {
    case 0:
    case "FILTER_CATEGORY_UNKNOWN":
      return FilterCategory.FILTER_CATEGORY_UNKNOWN;
    case 1:
    case "ALL":
      return FilterCategory.ALL;
    case 2:
    case "DESCRIPTIVE":
      return FilterCategory.DESCRIPTIVE;
    case 3:
    case "FINANCIALS":
      return FilterCategory.FINANCIALS;
    case 4:
    case "TECHNICALS":
      return FilterCategory.TECHNICALS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FilterCategory.UNRECOGNIZED;
  }
}

export function filterCategoryToJSON(object: FilterCategory): string {
  switch (object) {
    case FilterCategory.FILTER_CATEGORY_UNKNOWN:
      return "FILTER_CATEGORY_UNKNOWN";
    case FilterCategory.ALL:
      return "ALL";
    case FilterCategory.DESCRIPTIVE:
      return "DESCRIPTIVE";
    case FilterCategory.FINANCIALS:
      return "FINANCIALS";
    case FilterCategory.TECHNICALS:
      return "TECHNICALS";
    case FilterCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FieldType {
  FIELD_TYPE_UNKNOWN = 0,
  BOOL = 1,
  TEXT = 2,
  PRICE = 3,
  FUNDAMENTAL_PRICE = 4,
  NUMBER = 5,
  PERCENT = 6,
  PERCENT_CHANGE = 7,
  FINANCIAL_VALUE = 8,
  UNRECOGNIZED = -1,
}

export function fieldTypeFromJSON(object: any): FieldType {
  switch (object) {
    case 0:
    case "FIELD_TYPE_UNKNOWN":
      return FieldType.FIELD_TYPE_UNKNOWN;
    case 1:
    case "BOOL":
      return FieldType.BOOL;
    case 2:
    case "TEXT":
      return FieldType.TEXT;
    case 3:
    case "PRICE":
      return FieldType.PRICE;
    case 4:
    case "FUNDAMENTAL_PRICE":
      return FieldType.FUNDAMENTAL_PRICE;
    case 5:
    case "NUMBER":
      return FieldType.NUMBER;
    case 6:
    case "PERCENT":
      return FieldType.PERCENT;
    case 7:
    case "PERCENT_CHANGE":
      return FieldType.PERCENT_CHANGE;
    case 8:
    case "FINANCIAL_VALUE":
      return FieldType.FINANCIAL_VALUE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldType.UNRECOGNIZED;
  }
}

export function fieldTypeToJSON(object: FieldType): string {
  switch (object) {
    case FieldType.FIELD_TYPE_UNKNOWN:
      return "FIELD_TYPE_UNKNOWN";
    case FieldType.BOOL:
      return "BOOL";
    case FieldType.TEXT:
      return "TEXT";
    case FieldType.PRICE:
      return "PRICE";
    case FieldType.FUNDAMENTAL_PRICE:
      return "FUNDAMENTAL_PRICE";
    case FieldType.NUMBER:
      return "NUMBER";
    case FieldType.PERCENT:
      return "PERCENT";
    case FieldType.PERCENT_CHANGE:
      return "PERCENT_CHANGE";
    case FieldType.FINANCIAL_VALUE:
      return "FINANCIAL_VALUE";
    case FieldType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ScreenerEmailFrequency {
  SCREENER_EMAIL_FREQUENCY_UNKNOWN = 0,
  DAILY = 1,
  UNRECOGNIZED = -1,
}

export function screenerEmailFrequencyFromJSON(object: any): ScreenerEmailFrequency {
  switch (object) {
    case 0:
    case "SCREENER_EMAIL_FREQUENCY_UNKNOWN":
      return ScreenerEmailFrequency.SCREENER_EMAIL_FREQUENCY_UNKNOWN;
    case 1:
    case "DAILY":
      return ScreenerEmailFrequency.DAILY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScreenerEmailFrequency.UNRECOGNIZED;
  }
}

export function screenerEmailFrequencyToJSON(object: ScreenerEmailFrequency): string {
  switch (object) {
    case ScreenerEmailFrequency.SCREENER_EMAIL_FREQUENCY_UNKNOWN:
      return "SCREENER_EMAIL_FREQUENCY_UNKNOWN";
    case ScreenerEmailFrequency.DAILY:
      return "DAILY";
    case ScreenerEmailFrequency.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ScreenerEmailTime {
  SCREENER_EMAIL_TIME_UNKNOWN = 0,
  PREOPEN = 1,
  POSTCLOSE = 2,
  DAYEND = 3,
  TIME_10_AM = 4,
  TIME_11_AM = 5,
  TIME_12_PM = 6,
  TIME_1_PM = 7,
  TIME_2_PM = 8,
  TIME_3_PM = 9,
  UNRECOGNIZED = -1,
}

export function screenerEmailTimeFromJSON(object: any): ScreenerEmailTime {
  switch (object) {
    case 0:
    case "SCREENER_EMAIL_TIME_UNKNOWN":
      return ScreenerEmailTime.SCREENER_EMAIL_TIME_UNKNOWN;
    case 1:
    case "PREOPEN":
      return ScreenerEmailTime.PREOPEN;
    case 2:
    case "POSTCLOSE":
      return ScreenerEmailTime.POSTCLOSE;
    case 3:
    case "DAYEND":
      return ScreenerEmailTime.DAYEND;
    case 4:
    case "TIME_10_AM":
      return ScreenerEmailTime.TIME_10_AM;
    case 5:
    case "TIME_11_AM":
      return ScreenerEmailTime.TIME_11_AM;
    case 6:
    case "TIME_12_PM":
      return ScreenerEmailTime.TIME_12_PM;
    case 7:
    case "TIME_1_PM":
      return ScreenerEmailTime.TIME_1_PM;
    case 8:
    case "TIME_2_PM":
      return ScreenerEmailTime.TIME_2_PM;
    case 9:
    case "TIME_3_PM":
      return ScreenerEmailTime.TIME_3_PM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScreenerEmailTime.UNRECOGNIZED;
  }
}

export function screenerEmailTimeToJSON(object: ScreenerEmailTime): string {
  switch (object) {
    case ScreenerEmailTime.SCREENER_EMAIL_TIME_UNKNOWN:
      return "SCREENER_EMAIL_TIME_UNKNOWN";
    case ScreenerEmailTime.PREOPEN:
      return "PREOPEN";
    case ScreenerEmailTime.POSTCLOSE:
      return "POSTCLOSE";
    case ScreenerEmailTime.DAYEND:
      return "DAYEND";
    case ScreenerEmailTime.TIME_10_AM:
      return "TIME_10_AM";
    case ScreenerEmailTime.TIME_11_AM:
      return "TIME_11_AM";
    case ScreenerEmailTime.TIME_12_PM:
      return "TIME_12_PM";
    case ScreenerEmailTime.TIME_1_PM:
      return "TIME_1_PM";
    case ScreenerEmailTime.TIME_2_PM:
      return "TIME_2_PM";
    case ScreenerEmailTime.TIME_3_PM:
      return "TIME_3_PM";
    case ScreenerEmailTime.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ScreenerFilterValue {
  type: ScreenerFilterValue_Type;
  value: string;
}

export enum ScreenerFilterValue_Type {
  FILTER_OPERAND_TYPE_UNKNOWN = 0,
  FIELD = 1,
  FIXED_VALUE = 2,
  UNRECOGNIZED = -1,
}

export function screenerFilterValue_TypeFromJSON(object: any): ScreenerFilterValue_Type {
  switch (object) {
    case 0:
    case "FILTER_OPERAND_TYPE_UNKNOWN":
      return ScreenerFilterValue_Type.FILTER_OPERAND_TYPE_UNKNOWN;
    case 1:
    case "FIELD":
      return ScreenerFilterValue_Type.FIELD;
    case 2:
    case "FIXED_VALUE":
      return ScreenerFilterValue_Type.FIXED_VALUE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScreenerFilterValue_Type.UNRECOGNIZED;
  }
}

export function screenerFilterValue_TypeToJSON(object: ScreenerFilterValue_Type): string {
  switch (object) {
    case ScreenerFilterValue_Type.FILTER_OPERAND_TYPE_UNKNOWN:
      return "FILTER_OPERAND_TYPE_UNKNOWN";
    case ScreenerFilterValue_Type.FIELD:
      return "FIELD";
    case ScreenerFilterValue_Type.FIXED_VALUE:
      return "FIXED_VALUE";
    case ScreenerFilterValue_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface FieldParameterValue {
  name: string;
  value: string;
}

export interface FieldFilterParameter {
  name: string;
  code: string;
  type: FieldParameterType;
  value: FieldParameterValue | undefined;
}

export interface FieldParameter {
  name: string;
  code: string;
  type: FieldParameterType;
  values: FieldParameterValue[];
  defaultValue: FieldParameterValue | undefined;
}

export interface Multiplier {
  value: string;
  type: MultiplierType;
}

export interface ScreenerFilterOperand {
  parameters: FieldFilterParameter[];
  filterValue: ScreenerFilterValue | undefined;
  multiplier: Multiplier | undefined;
}

export interface ScreenerFilterCondition {
  lhsOperand: ScreenerFilterOperand | undefined;
  operator: Operator;
  rhsOperands: ScreenerFilterOperand[];
}

export interface Filters {
  filters: ScreenerFilter[];
}

export interface ScreenerFilter {
  name?: string | undefined;
  description?: string | undefined;
  predefined: boolean;
  filterCondition: ScreenerFilterCondition | undefined;
}

export interface ScreenerConfiguration {
  globalColumnSets: GlobalScreenerColumnSets | undefined;
  globalScreenerColumns: GlobalScreenerColumns | undefined;
  screenerFields: ScreenerFields | undefined;
}

export interface GlobalScreenerColumnSet {
  code: string;
  columns: GlobalScreenerColumnSet_Column[];
}

export interface GlobalScreenerColumnSet_Column {
  code: string;
  parameters: FieldFilterParameter[];
}

export interface GlobalScreenerColumnSets {
  columnSets: GlobalScreenerColumnSet[];
}

export interface GlobalScreenerColumn {
  code: string;
  displayName: string;
  dataType: DataType;
  description: string;
  fieldCodes: string[];
  hidden: boolean;
  filterConfiguration: ScreenerColumnFilterConfiguration | undefined;
  preDefinedFilters: ScreenerFilter[];
  columnGroups: string[];
  minWidth: number;
  category: GlobalScreenerColumn_Category;
  subCategory?: string | undefined;
}

export enum GlobalScreenerColumn_Category {
  UNKNOWN = 0,
  SECURITY_INFO = 1,
  MARKET_DATA = 2,
  TECHNICALS = 3,
  FNO = 4,
  VALUATION = 5,
  FUNDAMENTALS = 6,
  SHAREHOLDING = 7,
  UNRECOGNIZED = -1,
}

export function globalScreenerColumn_CategoryFromJSON(object: any): GlobalScreenerColumn_Category {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return GlobalScreenerColumn_Category.UNKNOWN;
    case 1:
    case "SECURITY_INFO":
      return GlobalScreenerColumn_Category.SECURITY_INFO;
    case 2:
    case "MARKET_DATA":
      return GlobalScreenerColumn_Category.MARKET_DATA;
    case 3:
    case "TECHNICALS":
      return GlobalScreenerColumn_Category.TECHNICALS;
    case 4:
    case "FNO":
      return GlobalScreenerColumn_Category.FNO;
    case 5:
    case "VALUATION":
      return GlobalScreenerColumn_Category.VALUATION;
    case 6:
    case "FUNDAMENTALS":
      return GlobalScreenerColumn_Category.FUNDAMENTALS;
    case 7:
    case "SHAREHOLDING":
      return GlobalScreenerColumn_Category.SHAREHOLDING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GlobalScreenerColumn_Category.UNRECOGNIZED;
  }
}

export function globalScreenerColumn_CategoryToJSON(object: GlobalScreenerColumn_Category): string {
  switch (object) {
    case GlobalScreenerColumn_Category.UNKNOWN:
      return "UNKNOWN";
    case GlobalScreenerColumn_Category.SECURITY_INFO:
      return "SECURITY_INFO";
    case GlobalScreenerColumn_Category.MARKET_DATA:
      return "MARKET_DATA";
    case GlobalScreenerColumn_Category.TECHNICALS:
      return "TECHNICALS";
    case GlobalScreenerColumn_Category.FNO:
      return "FNO";
    case GlobalScreenerColumn_Category.VALUATION:
      return "VALUATION";
    case GlobalScreenerColumn_Category.FUNDAMENTALS:
      return "FUNDAMENTALS";
    case GlobalScreenerColumn_Category.SHAREHOLDING:
      return "SHAREHOLDING";
    case GlobalScreenerColumn_Category.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ScreenerColumnFilterConfiguration {
  filterCategory: FilterCategory;
  operatorsSupported: Operator[];
  filterType: FilterType;
  range?: ScreenerColumnFilterConfiguration_Range | undefined;
  selectValues?: ScreenerColumnFilterConfiguration_SelectValues | undefined;
}

export interface ScreenerColumnFilterConfiguration_Range {
  minValue: string;
  maxValue: string;
}

export interface ScreenerColumnFilterConfiguration_SelectValues {
  selectValues: ScreenerColumnFilterConfiguration_SelectValues_SelectValue[];
}

export interface ScreenerColumnFilterConfiguration_SelectValues_SelectValue {
  code: string;
  name: string;
}

export interface GlobalScreenerColumns {
  columns: GlobalScreenerColumn[];
  initialFilterColumns: string[];
}

export interface ScanScreenerRequest {
  filters?: Filters | undefined;
  queryExpression?: string | undefined;
  sort: SortBy | undefined;
  fields: string[];
  maxSize: number;
}

export interface AddToWatchlistRequest {
  screenerId: string;
  watchlist: Watchlist | undefined;
}

export interface ExportScreenerRequest {
  filters?: Filters | undefined;
  queryExpression?: string | undefined;
  sort: SortBy | undefined;
  fields: string[];
}

export interface ExportScreenerResponse {
  data: ScanScreenerResponse_ScreenerSecurityData[];
}

export interface ScanScreenerResponse {
  data: ScanScreenerResponse_ScreenerSecurityData[];
  totalCount: number;
}

export interface ScanScreenerResponse_ScreenerSecurityData {
  exchange: Exchange;
  code: string;
  data: string[];
}

export interface ScreenerField {
  code: string;
  dataType: DataType;
  fieldType: FieldType;
  abbreviate: boolean;
  precision: number;
  parameters: FieldParameter[];
}

export interface ScreenerFields {
  fields: ScreenerField[];
}

export interface ScreenerFeedbackRequest {
  feedback: Feedback[];
}

export interface Feedback {
  query: string;
  generatedFilters: ScreenerFilter[];
  updatedFilters: ScreenerFilter[];
}

export interface SubscriptionList {
  screenerIds: string[];
}

export interface UpdateSubscriptionRequest {
  screenerId: string;
  subscribe: boolean;
  userId?: string | undefined;
  frequency?: ScreenerEmailFrequency | undefined;
  emailSendTime?: ScreenerEmailTime | undefined;
  notificationChannel?: NotificationChannel | undefined;
}

export interface CustomScreenerColumnRequest {
  userId?: string | undefined;
  screenerColumn: string;
}

export interface CustomScreenColumn {
  screenerColumn: string;
  id: string;
}

export interface DeleteScreenerCustomColumnRequest {
  userId?: string | undefined;
  id: string;
}

export interface CustomScreenerColumns {
  columns: CustomScreenColumn[];
}

export interface ScreenerColumnMetadata {
  columnCode: string;
  fieldCode: string;
  displayName: string;
  isNumeric: boolean;
  precision: number;
  fieldType?: FieldType | undefined;
  abbreviate: boolean;
  dataType: DataType;
}

export interface SecurityScreenerMetaDataResponse {
  columnMetadata: ScreenerColumnMetadata[];
}

export interface ScreenerSubscriptionDataRequest {
  userId: string;
  email: string;
  name: string;
  data: ScreenData[];
}

export interface ScreenData {
  screenerLayout: UserScreenerLayout | undefined;
  filters: Filters | undefined;
  sortBy: SortBy | undefined;
}

export interface SendScreenerEmailRequest {
  email: string;
  name: string;
  screenerId: string;
}

function createBaseScreenerFilterValue(): ScreenerFilterValue {
  return { type: 0, value: "" };
}

export const ScreenerFilterValue = {
  encode(message: ScreenerFilterValue, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerFilterValue {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerFilterValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerFilterValue {
    return {
      type: isSet(object.type) ? screenerFilterValue_TypeFromJSON(object.type) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: ScreenerFilterValue): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = screenerFilterValue_TypeToJSON(message.type);
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerFilterValue>, I>>(base?: I): ScreenerFilterValue {
    return ScreenerFilterValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerFilterValue>, I>>(object: I): ScreenerFilterValue {
    const message = createBaseScreenerFilterValue();
    message.type = object.type ?? 0;
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseFieldParameterValue(): FieldParameterValue {
  return { name: "", value: "" };
}

export const FieldParameterValue = {
  encode(message: FieldParameterValue, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FieldParameterValue {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFieldParameterValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FieldParameterValue {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: FieldParameterValue): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FieldParameterValue>, I>>(base?: I): FieldParameterValue {
    return FieldParameterValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FieldParameterValue>, I>>(object: I): FieldParameterValue {
    const message = createBaseFieldParameterValue();
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseFieldFilterParameter(): FieldFilterParameter {
  return { name: "", code: "", type: 0, value: undefined };
}

export const FieldFilterParameter = {
  encode(message: FieldFilterParameter, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    if (message.value !== undefined) {
      FieldParameterValue.encode(message.value, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FieldFilterParameter {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFieldFilterParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.value = FieldParameterValue.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FieldFilterParameter {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      type: isSet(object.type) ? fieldParameterTypeFromJSON(object.type) : 0,
      value: isSet(object.value) ? FieldParameterValue.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: FieldFilterParameter): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.type !== 0) {
      obj.type = fieldParameterTypeToJSON(message.type);
    }
    if (message.value !== undefined) {
      obj.value = FieldParameterValue.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FieldFilterParameter>, I>>(base?: I): FieldFilterParameter {
    return FieldFilterParameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FieldFilterParameter>, I>>(object: I): FieldFilterParameter {
    const message = createBaseFieldFilterParameter();
    message.name = object.name ?? "";
    message.code = object.code ?? "";
    message.type = object.type ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? FieldParameterValue.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseFieldParameter(): FieldParameter {
  return { name: "", code: "", type: 0, values: [], defaultValue: undefined };
}

export const FieldParameter = {
  encode(message: FieldParameter, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    for (const v of message.values) {
      FieldParameterValue.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.defaultValue !== undefined) {
      FieldParameterValue.encode(message.defaultValue, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FieldParameter {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFieldParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.values.push(FieldParameterValue.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.defaultValue = FieldParameterValue.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FieldParameter {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      type: isSet(object.type) ? fieldParameterTypeFromJSON(object.type) : 0,
      values: globalThis.Array.isArray(object?.values)
        ? object.values.map((e: any) => FieldParameterValue.fromJSON(e))
        : [],
      defaultValue: isSet(object.defaultValue) ? FieldParameterValue.fromJSON(object.defaultValue) : undefined,
    };
  },

  toJSON(message: FieldParameter): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.type !== 0) {
      obj.type = fieldParameterTypeToJSON(message.type);
    }
    if (message.values?.length) {
      obj.values = message.values.map((e) => FieldParameterValue.toJSON(e));
    }
    if (message.defaultValue !== undefined) {
      obj.defaultValue = FieldParameterValue.toJSON(message.defaultValue);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FieldParameter>, I>>(base?: I): FieldParameter {
    return FieldParameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FieldParameter>, I>>(object: I): FieldParameter {
    const message = createBaseFieldParameter();
    message.name = object.name ?? "";
    message.code = object.code ?? "";
    message.type = object.type ?? 0;
    message.values = object.values?.map((e) => FieldParameterValue.fromPartial(e)) || [];
    message.defaultValue = (object.defaultValue !== undefined && object.defaultValue !== null)
      ? FieldParameterValue.fromPartial(object.defaultValue)
      : undefined;
    return message;
  },
};

function createBaseMultiplier(): Multiplier {
  return { value: "", type: 0 };
}

export const Multiplier = {
  encode(message: Multiplier, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.value !== "") {
      writer.uint32(10).string(message.value);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Multiplier {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiplier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.value = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Multiplier {
    return {
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      type: isSet(object.type) ? multiplierTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: Multiplier): unknown {
    const obj: any = {};
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.type !== 0) {
      obj.type = multiplierTypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Multiplier>, I>>(base?: I): Multiplier {
    return Multiplier.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Multiplier>, I>>(object: I): Multiplier {
    const message = createBaseMultiplier();
    message.value = object.value ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseScreenerFilterOperand(): ScreenerFilterOperand {
  return { parameters: [], filterValue: undefined, multiplier: undefined };
}

export const ScreenerFilterOperand = {
  encode(message: ScreenerFilterOperand, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.parameters) {
      FieldFilterParameter.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.filterValue !== undefined) {
      ScreenerFilterValue.encode(message.filterValue, writer.uint32(18).fork()).ldelim();
    }
    if (message.multiplier !== undefined) {
      Multiplier.encode(message.multiplier, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerFilterOperand {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerFilterOperand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.parameters.push(FieldFilterParameter.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.filterValue = ScreenerFilterValue.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.multiplier = Multiplier.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerFilterOperand {
    return {
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FieldFilterParameter.fromJSON(e))
        : [],
      filterValue: isSet(object.filterValue) ? ScreenerFilterValue.fromJSON(object.filterValue) : undefined,
      multiplier: isSet(object.multiplier) ? Multiplier.fromJSON(object.multiplier) : undefined,
    };
  },

  toJSON(message: ScreenerFilterOperand): unknown {
    const obj: any = {};
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FieldFilterParameter.toJSON(e));
    }
    if (message.filterValue !== undefined) {
      obj.filterValue = ScreenerFilterValue.toJSON(message.filterValue);
    }
    if (message.multiplier !== undefined) {
      obj.multiplier = Multiplier.toJSON(message.multiplier);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerFilterOperand>, I>>(base?: I): ScreenerFilterOperand {
    return ScreenerFilterOperand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerFilterOperand>, I>>(object: I): ScreenerFilterOperand {
    const message = createBaseScreenerFilterOperand();
    message.parameters = object.parameters?.map((e) => FieldFilterParameter.fromPartial(e)) || [];
    message.filterValue = (object.filterValue !== undefined && object.filterValue !== null)
      ? ScreenerFilterValue.fromPartial(object.filterValue)
      : undefined;
    message.multiplier = (object.multiplier !== undefined && object.multiplier !== null)
      ? Multiplier.fromPartial(object.multiplier)
      : undefined;
    return message;
  },
};

function createBaseScreenerFilterCondition(): ScreenerFilterCondition {
  return { lhsOperand: undefined, operator: 0, rhsOperands: [] };
}

export const ScreenerFilterCondition = {
  encode(message: ScreenerFilterCondition, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.lhsOperand !== undefined) {
      ScreenerFilterOperand.encode(message.lhsOperand, writer.uint32(10).fork()).ldelim();
    }
    if (message.operator !== 0) {
      writer.uint32(16).int32(message.operator);
    }
    for (const v of message.rhsOperands) {
      ScreenerFilterOperand.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerFilterCondition {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerFilterCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.lhsOperand = ScreenerFilterOperand.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.operator = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.rhsOperands.push(ScreenerFilterOperand.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerFilterCondition {
    return {
      lhsOperand: isSet(object.lhsOperand) ? ScreenerFilterOperand.fromJSON(object.lhsOperand) : undefined,
      operator: isSet(object.operator) ? operatorFromJSON(object.operator) : 0,
      rhsOperands: globalThis.Array.isArray(object?.rhsOperands)
        ? object.rhsOperands.map((e: any) => ScreenerFilterOperand.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScreenerFilterCondition): unknown {
    const obj: any = {};
    if (message.lhsOperand !== undefined) {
      obj.lhsOperand = ScreenerFilterOperand.toJSON(message.lhsOperand);
    }
    if (message.operator !== 0) {
      obj.operator = operatorToJSON(message.operator);
    }
    if (message.rhsOperands?.length) {
      obj.rhsOperands = message.rhsOperands.map((e) => ScreenerFilterOperand.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerFilterCondition>, I>>(base?: I): ScreenerFilterCondition {
    return ScreenerFilterCondition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerFilterCondition>, I>>(object: I): ScreenerFilterCondition {
    const message = createBaseScreenerFilterCondition();
    message.lhsOperand = (object.lhsOperand !== undefined && object.lhsOperand !== null)
      ? ScreenerFilterOperand.fromPartial(object.lhsOperand)
      : undefined;
    message.operator = object.operator ?? 0;
    message.rhsOperands = object.rhsOperands?.map((e) => ScreenerFilterOperand.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFilters(): Filters {
  return { filters: [] };
}

export const Filters = {
  encode(message: Filters, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.filters) {
      ScreenerFilter.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Filters {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.filters.push(ScreenerFilter.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Filters {
    return {
      filters: globalThis.Array.isArray(object?.filters)
        ? object.filters.map((e: any) => ScreenerFilter.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Filters): unknown {
    const obj: any = {};
    if (message.filters?.length) {
      obj.filters = message.filters.map((e) => ScreenerFilter.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Filters>, I>>(base?: I): Filters {
    return Filters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Filters>, I>>(object: I): Filters {
    const message = createBaseFilters();
    message.filters = object.filters?.map((e) => ScreenerFilter.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScreenerFilter(): ScreenerFilter {
  return { name: undefined, description: undefined, predefined: false, filterCondition: undefined };
}

export const ScreenerFilter = {
  encode(message: ScreenerFilter, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.predefined !== false) {
      writer.uint32(24).bool(message.predefined);
    }
    if (message.filterCondition !== undefined) {
      ScreenerFilterCondition.encode(message.filterCondition, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerFilter {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.predefined = reader.bool();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.filterCondition = ScreenerFilterCondition.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerFilter {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      predefined: isSet(object.predefined) ? globalThis.Boolean(object.predefined) : false,
      filterCondition: isSet(object.filterCondition)
        ? ScreenerFilterCondition.fromJSON(object.filterCondition)
        : undefined,
    };
  },

  toJSON(message: ScreenerFilter): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.predefined !== false) {
      obj.predefined = message.predefined;
    }
    if (message.filterCondition !== undefined) {
      obj.filterCondition = ScreenerFilterCondition.toJSON(message.filterCondition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerFilter>, I>>(base?: I): ScreenerFilter {
    return ScreenerFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerFilter>, I>>(object: I): ScreenerFilter {
    const message = createBaseScreenerFilter();
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.predefined = object.predefined ?? false;
    message.filterCondition = (object.filterCondition !== undefined && object.filterCondition !== null)
      ? ScreenerFilterCondition.fromPartial(object.filterCondition)
      : undefined;
    return message;
  },
};

function createBaseScreenerConfiguration(): ScreenerConfiguration {
  return { globalColumnSets: undefined, globalScreenerColumns: undefined, screenerFields: undefined };
}

export const ScreenerConfiguration = {
  encode(message: ScreenerConfiguration, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.globalColumnSets !== undefined) {
      GlobalScreenerColumnSets.encode(message.globalColumnSets, writer.uint32(10).fork()).ldelim();
    }
    if (message.globalScreenerColumns !== undefined) {
      GlobalScreenerColumns.encode(message.globalScreenerColumns, writer.uint32(18).fork()).ldelim();
    }
    if (message.screenerFields !== undefined) {
      ScreenerFields.encode(message.screenerFields, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerConfiguration {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.globalColumnSets = GlobalScreenerColumnSets.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.globalScreenerColumns = GlobalScreenerColumns.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.screenerFields = ScreenerFields.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerConfiguration {
    return {
      globalColumnSets: isSet(object.globalColumnSets)
        ? GlobalScreenerColumnSets.fromJSON(object.globalColumnSets)
        : undefined,
      globalScreenerColumns: isSet(object.globalScreenerColumns)
        ? GlobalScreenerColumns.fromJSON(object.globalScreenerColumns)
        : undefined,
      screenerFields: isSet(object.screenerFields) ? ScreenerFields.fromJSON(object.screenerFields) : undefined,
    };
  },

  toJSON(message: ScreenerConfiguration): unknown {
    const obj: any = {};
    if (message.globalColumnSets !== undefined) {
      obj.globalColumnSets = GlobalScreenerColumnSets.toJSON(message.globalColumnSets);
    }
    if (message.globalScreenerColumns !== undefined) {
      obj.globalScreenerColumns = GlobalScreenerColumns.toJSON(message.globalScreenerColumns);
    }
    if (message.screenerFields !== undefined) {
      obj.screenerFields = ScreenerFields.toJSON(message.screenerFields);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerConfiguration>, I>>(base?: I): ScreenerConfiguration {
    return ScreenerConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerConfiguration>, I>>(object: I): ScreenerConfiguration {
    const message = createBaseScreenerConfiguration();
    message.globalColumnSets = (object.globalColumnSets !== undefined && object.globalColumnSets !== null)
      ? GlobalScreenerColumnSets.fromPartial(object.globalColumnSets)
      : undefined;
    message.globalScreenerColumns =
      (object.globalScreenerColumns !== undefined && object.globalScreenerColumns !== null)
        ? GlobalScreenerColumns.fromPartial(object.globalScreenerColumns)
        : undefined;
    message.screenerFields = (object.screenerFields !== undefined && object.screenerFields !== null)
      ? ScreenerFields.fromPartial(object.screenerFields)
      : undefined;
    return message;
  },
};

function createBaseGlobalScreenerColumnSet(): GlobalScreenerColumnSet {
  return { code: "", columns: [] };
}

export const GlobalScreenerColumnSet = {
  encode(message: GlobalScreenerColumnSet, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    for (const v of message.columns) {
      GlobalScreenerColumnSet_Column.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalScreenerColumnSet {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalScreenerColumnSet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.columns.push(GlobalScreenerColumnSet_Column.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalScreenerColumnSet {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      columns: globalThis.Array.isArray(object?.columns)
        ? object.columns.map((e: any) => GlobalScreenerColumnSet_Column.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GlobalScreenerColumnSet): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.columns?.length) {
      obj.columns = message.columns.map((e) => GlobalScreenerColumnSet_Column.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalScreenerColumnSet>, I>>(base?: I): GlobalScreenerColumnSet {
    return GlobalScreenerColumnSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalScreenerColumnSet>, I>>(object: I): GlobalScreenerColumnSet {
    const message = createBaseGlobalScreenerColumnSet();
    message.code = object.code ?? "";
    message.columns = object.columns?.map((e) => GlobalScreenerColumnSet_Column.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGlobalScreenerColumnSet_Column(): GlobalScreenerColumnSet_Column {
  return { code: "", parameters: [] };
}

export const GlobalScreenerColumnSet_Column = {
  encode(message: GlobalScreenerColumnSet_Column, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    for (const v of message.parameters) {
      FieldFilterParameter.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalScreenerColumnSet_Column {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalScreenerColumnSet_Column();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.parameters.push(FieldFilterParameter.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalScreenerColumnSet_Column {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FieldFilterParameter.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GlobalScreenerColumnSet_Column): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FieldFilterParameter.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalScreenerColumnSet_Column>, I>>(base?: I): GlobalScreenerColumnSet_Column {
    return GlobalScreenerColumnSet_Column.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalScreenerColumnSet_Column>, I>>(
    object: I,
  ): GlobalScreenerColumnSet_Column {
    const message = createBaseGlobalScreenerColumnSet_Column();
    message.code = object.code ?? "";
    message.parameters = object.parameters?.map((e) => FieldFilterParameter.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGlobalScreenerColumnSets(): GlobalScreenerColumnSets {
  return { columnSets: [] };
}

export const GlobalScreenerColumnSets = {
  encode(message: GlobalScreenerColumnSets, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.columnSets) {
      GlobalScreenerColumnSet.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalScreenerColumnSets {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalScreenerColumnSets();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.columnSets.push(GlobalScreenerColumnSet.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalScreenerColumnSets {
    return {
      columnSets: globalThis.Array.isArray(object?.columnSets)
        ? object.columnSets.map((e: any) => GlobalScreenerColumnSet.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GlobalScreenerColumnSets): unknown {
    const obj: any = {};
    if (message.columnSets?.length) {
      obj.columnSets = message.columnSets.map((e) => GlobalScreenerColumnSet.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalScreenerColumnSets>, I>>(base?: I): GlobalScreenerColumnSets {
    return GlobalScreenerColumnSets.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalScreenerColumnSets>, I>>(object: I): GlobalScreenerColumnSets {
    const message = createBaseGlobalScreenerColumnSets();
    message.columnSets = object.columnSets?.map((e) => GlobalScreenerColumnSet.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGlobalScreenerColumn(): GlobalScreenerColumn {
  return {
    code: "",
    displayName: "",
    dataType: 0,
    description: "",
    fieldCodes: [],
    hidden: false,
    filterConfiguration: undefined,
    preDefinedFilters: [],
    columnGroups: [],
    minWidth: 0,
    category: 0,
    subCategory: undefined,
  };
}

export const GlobalScreenerColumn = {
  encode(message: GlobalScreenerColumn, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    if (message.dataType !== 0) {
      writer.uint32(24).int32(message.dataType);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    for (const v of message.fieldCodes) {
      writer.uint32(82).string(v!);
    }
    if (message.hidden !== false) {
      writer.uint32(88).bool(message.hidden);
    }
    if (message.filterConfiguration !== undefined) {
      ScreenerColumnFilterConfiguration.encode(message.filterConfiguration, writer.uint32(98).fork()).ldelim();
    }
    for (const v of message.preDefinedFilters) {
      ScreenerFilter.encode(v!, writer.uint32(114).fork()).ldelim();
    }
    for (const v of message.columnGroups) {
      writer.uint32(122).string(v!);
    }
    if (message.minWidth !== 0) {
      writer.uint32(128).int32(message.minWidth);
    }
    if (message.category !== 0) {
      writer.uint32(136).int32(message.category);
    }
    if (message.subCategory !== undefined) {
      writer.uint32(146).string(message.subCategory);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalScreenerColumn {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalScreenerColumn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.dataType = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.fieldCodes.push(reader.string());
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.hidden = reader.bool();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.filterConfiguration = ScreenerColumnFilterConfiguration.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.preDefinedFilters.push(ScreenerFilter.decode(reader, reader.uint32()));
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.columnGroups.push(reader.string());
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.minWidth = reader.int32();
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.subCategory = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalScreenerColumn {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      dataType: isSet(object.dataType) ? dataTypeFromJSON(object.dataType) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      fieldCodes: globalThis.Array.isArray(object?.fieldCodes)
        ? object.fieldCodes.map((e: any) => globalThis.String(e))
        : [],
      hidden: isSet(object.hidden) ? globalThis.Boolean(object.hidden) : false,
      filterConfiguration: isSet(object.filterConfiguration)
        ? ScreenerColumnFilterConfiguration.fromJSON(object.filterConfiguration)
        : undefined,
      preDefinedFilters: globalThis.Array.isArray(object?.preDefinedFilters)
        ? object.preDefinedFilters.map((e: any) => ScreenerFilter.fromJSON(e))
        : [],
      columnGroups: globalThis.Array.isArray(object?.columnGroups)
        ? object.columnGroups.map((e: any) => globalThis.String(e))
        : [],
      minWidth: isSet(object.minWidth) ? globalThis.Number(object.minWidth) : 0,
      category: isSet(object.category) ? globalScreenerColumn_CategoryFromJSON(object.category) : 0,
      subCategory: isSet(object.subCategory) ? globalThis.String(object.subCategory) : undefined,
    };
  },

  toJSON(message: GlobalScreenerColumn): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.dataType !== 0) {
      obj.dataType = dataTypeToJSON(message.dataType);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.fieldCodes?.length) {
      obj.fieldCodes = message.fieldCodes;
    }
    if (message.hidden !== false) {
      obj.hidden = message.hidden;
    }
    if (message.filterConfiguration !== undefined) {
      obj.filterConfiguration = ScreenerColumnFilterConfiguration.toJSON(message.filterConfiguration);
    }
    if (message.preDefinedFilters?.length) {
      obj.preDefinedFilters = message.preDefinedFilters.map((e) => ScreenerFilter.toJSON(e));
    }
    if (message.columnGroups?.length) {
      obj.columnGroups = message.columnGroups;
    }
    if (message.minWidth !== 0) {
      obj.minWidth = Math.round(message.minWidth);
    }
    if (message.category !== 0) {
      obj.category = globalScreenerColumn_CategoryToJSON(message.category);
    }
    if (message.subCategory !== undefined) {
      obj.subCategory = message.subCategory;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalScreenerColumn>, I>>(base?: I): GlobalScreenerColumn {
    return GlobalScreenerColumn.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalScreenerColumn>, I>>(object: I): GlobalScreenerColumn {
    const message = createBaseGlobalScreenerColumn();
    message.code = object.code ?? "";
    message.displayName = object.displayName ?? "";
    message.dataType = object.dataType ?? 0;
    message.description = object.description ?? "";
    message.fieldCodes = object.fieldCodes?.map((e) => e) || [];
    message.hidden = object.hidden ?? false;
    message.filterConfiguration = (object.filterConfiguration !== undefined && object.filterConfiguration !== null)
      ? ScreenerColumnFilterConfiguration.fromPartial(object.filterConfiguration)
      : undefined;
    message.preDefinedFilters = object.preDefinedFilters?.map((e) => ScreenerFilter.fromPartial(e)) || [];
    message.columnGroups = object.columnGroups?.map((e) => e) || [];
    message.minWidth = object.minWidth ?? 0;
    message.category = object.category ?? 0;
    message.subCategory = object.subCategory ?? undefined;
    return message;
  },
};

function createBaseScreenerColumnFilterConfiguration(): ScreenerColumnFilterConfiguration {
  return { filterCategory: 0, operatorsSupported: [], filterType: 0, range: undefined, selectValues: undefined };
}

export const ScreenerColumnFilterConfiguration = {
  encode(message: ScreenerColumnFilterConfiguration, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.filterCategory !== 0) {
      writer.uint32(16).int32(message.filterCategory);
    }
    writer.uint32(34).fork();
    for (const v of message.operatorsSupported) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.filterType !== 0) {
      writer.uint32(80).int32(message.filterType);
    }
    if (message.range !== undefined) {
      ScreenerColumnFilterConfiguration_Range.encode(message.range, writer.uint32(98).fork()).ldelim();
    }
    if (message.selectValues !== undefined) {
      ScreenerColumnFilterConfiguration_SelectValues.encode(message.selectValues, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerColumnFilterConfiguration {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerColumnFilterConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 16) {
            break;
          }

          message.filterCategory = reader.int32() as any;
          continue;
        case 4:
          if (tag === 32) {
            message.operatorsSupported.push(reader.int32() as any);

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.operatorsSupported.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.filterType = reader.int32() as any;
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.range = ScreenerColumnFilterConfiguration_Range.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.selectValues = ScreenerColumnFilterConfiguration_SelectValues.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerColumnFilterConfiguration {
    return {
      filterCategory: isSet(object.filterCategory) ? filterCategoryFromJSON(object.filterCategory) : 0,
      operatorsSupported: globalThis.Array.isArray(object?.operatorsSupported)
        ? object.operatorsSupported.map((e: any) => operatorFromJSON(e))
        : [],
      filterType: isSet(object.filterType) ? filterTypeFromJSON(object.filterType) : 0,
      range: isSet(object.range) ? ScreenerColumnFilterConfiguration_Range.fromJSON(object.range) : undefined,
      selectValues: isSet(object.selectValues)
        ? ScreenerColumnFilterConfiguration_SelectValues.fromJSON(object.selectValues)
        : undefined,
    };
  },

  toJSON(message: ScreenerColumnFilterConfiguration): unknown {
    const obj: any = {};
    if (message.filterCategory !== 0) {
      obj.filterCategory = filterCategoryToJSON(message.filterCategory);
    }
    if (message.operatorsSupported?.length) {
      obj.operatorsSupported = message.operatorsSupported.map((e) => operatorToJSON(e));
    }
    if (message.filterType !== 0) {
      obj.filterType = filterTypeToJSON(message.filterType);
    }
    if (message.range !== undefined) {
      obj.range = ScreenerColumnFilterConfiguration_Range.toJSON(message.range);
    }
    if (message.selectValues !== undefined) {
      obj.selectValues = ScreenerColumnFilterConfiguration_SelectValues.toJSON(message.selectValues);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerColumnFilterConfiguration>, I>>(
    base?: I,
  ): ScreenerColumnFilterConfiguration {
    return ScreenerColumnFilterConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerColumnFilterConfiguration>, I>>(
    object: I,
  ): ScreenerColumnFilterConfiguration {
    const message = createBaseScreenerColumnFilterConfiguration();
    message.filterCategory = object.filterCategory ?? 0;
    message.operatorsSupported = object.operatorsSupported?.map((e) => e) || [];
    message.filterType = object.filterType ?? 0;
    message.range = (object.range !== undefined && object.range !== null)
      ? ScreenerColumnFilterConfiguration_Range.fromPartial(object.range)
      : undefined;
    message.selectValues = (object.selectValues !== undefined && object.selectValues !== null)
      ? ScreenerColumnFilterConfiguration_SelectValues.fromPartial(object.selectValues)
      : undefined;
    return message;
  },
};

function createBaseScreenerColumnFilterConfiguration_Range(): ScreenerColumnFilterConfiguration_Range {
  return { minValue: "", maxValue: "" };
}

export const ScreenerColumnFilterConfiguration_Range = {
  encode(message: ScreenerColumnFilterConfiguration_Range, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.minValue !== "") {
      writer.uint32(10).string(message.minValue);
    }
    if (message.maxValue !== "") {
      writer.uint32(18).string(message.maxValue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerColumnFilterConfiguration_Range {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerColumnFilterConfiguration_Range();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.minValue = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.maxValue = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerColumnFilterConfiguration_Range {
    return {
      minValue: isSet(object.minValue) ? globalThis.String(object.minValue) : "",
      maxValue: isSet(object.maxValue) ? globalThis.String(object.maxValue) : "",
    };
  },

  toJSON(message: ScreenerColumnFilterConfiguration_Range): unknown {
    const obj: any = {};
    if (message.minValue !== "") {
      obj.minValue = message.minValue;
    }
    if (message.maxValue !== "") {
      obj.maxValue = message.maxValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerColumnFilterConfiguration_Range>, I>>(
    base?: I,
  ): ScreenerColumnFilterConfiguration_Range {
    return ScreenerColumnFilterConfiguration_Range.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerColumnFilterConfiguration_Range>, I>>(
    object: I,
  ): ScreenerColumnFilterConfiguration_Range {
    const message = createBaseScreenerColumnFilterConfiguration_Range();
    message.minValue = object.minValue ?? "";
    message.maxValue = object.maxValue ?? "";
    return message;
  },
};

function createBaseScreenerColumnFilterConfiguration_SelectValues(): ScreenerColumnFilterConfiguration_SelectValues {
  return { selectValues: [] };
}

export const ScreenerColumnFilterConfiguration_SelectValues = {
  encode(
    message: ScreenerColumnFilterConfiguration_SelectValues,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    for (const v of message.selectValues) {
      ScreenerColumnFilterConfiguration_SelectValues_SelectValue.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerColumnFilterConfiguration_SelectValues {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerColumnFilterConfiguration_SelectValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.selectValues.push(
            ScreenerColumnFilterConfiguration_SelectValues_SelectValue.decode(reader, reader.uint32()),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerColumnFilterConfiguration_SelectValues {
    return {
      selectValues: globalThis.Array.isArray(object?.selectValues)
        ? object.selectValues.map((e: any) => ScreenerColumnFilterConfiguration_SelectValues_SelectValue.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScreenerColumnFilterConfiguration_SelectValues): unknown {
    const obj: any = {};
    if (message.selectValues?.length) {
      obj.selectValues = message.selectValues.map((e) =>
        ScreenerColumnFilterConfiguration_SelectValues_SelectValue.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerColumnFilterConfiguration_SelectValues>, I>>(
    base?: I,
  ): ScreenerColumnFilterConfiguration_SelectValues {
    return ScreenerColumnFilterConfiguration_SelectValues.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerColumnFilterConfiguration_SelectValues>, I>>(
    object: I,
  ): ScreenerColumnFilterConfiguration_SelectValues {
    const message = createBaseScreenerColumnFilterConfiguration_SelectValues();
    message.selectValues =
      object.selectValues?.map((e) => ScreenerColumnFilterConfiguration_SelectValues_SelectValue.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScreenerColumnFilterConfiguration_SelectValues_SelectValue(): ScreenerColumnFilterConfiguration_SelectValues_SelectValue {
  return { code: "", name: "" };
}

export const ScreenerColumnFilterConfiguration_SelectValues_SelectValue = {
  encode(
    message: ScreenerColumnFilterConfiguration_SelectValues_SelectValue,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerColumnFilterConfiguration_SelectValues_SelectValue {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerColumnFilterConfiguration_SelectValues_SelectValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerColumnFilterConfiguration_SelectValues_SelectValue {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: ScreenerColumnFilterConfiguration_SelectValues_SelectValue): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerColumnFilterConfiguration_SelectValues_SelectValue>, I>>(
    base?: I,
  ): ScreenerColumnFilterConfiguration_SelectValues_SelectValue {
    return ScreenerColumnFilterConfiguration_SelectValues_SelectValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerColumnFilterConfiguration_SelectValues_SelectValue>, I>>(
    object: I,
  ): ScreenerColumnFilterConfiguration_SelectValues_SelectValue {
    const message = createBaseScreenerColumnFilterConfiguration_SelectValues_SelectValue();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseGlobalScreenerColumns(): GlobalScreenerColumns {
  return { columns: [], initialFilterColumns: [] };
}

export const GlobalScreenerColumns = {
  encode(message: GlobalScreenerColumns, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.columns) {
      GlobalScreenerColumn.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.initialFilterColumns) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalScreenerColumns {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalScreenerColumns();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.columns.push(GlobalScreenerColumn.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.initialFilterColumns.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalScreenerColumns {
    return {
      columns: globalThis.Array.isArray(object?.columns)
        ? object.columns.map((e: any) => GlobalScreenerColumn.fromJSON(e))
        : [],
      initialFilterColumns: globalThis.Array.isArray(object?.initialFilterColumns)
        ? object.initialFilterColumns.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GlobalScreenerColumns): unknown {
    const obj: any = {};
    if (message.columns?.length) {
      obj.columns = message.columns.map((e) => GlobalScreenerColumn.toJSON(e));
    }
    if (message.initialFilterColumns?.length) {
      obj.initialFilterColumns = message.initialFilterColumns;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalScreenerColumns>, I>>(base?: I): GlobalScreenerColumns {
    return GlobalScreenerColumns.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalScreenerColumns>, I>>(object: I): GlobalScreenerColumns {
    const message = createBaseGlobalScreenerColumns();
    message.columns = object.columns?.map((e) => GlobalScreenerColumn.fromPartial(e)) || [];
    message.initialFilterColumns = object.initialFilterColumns?.map((e) => e) || [];
    return message;
  },
};

function createBaseScanScreenerRequest(): ScanScreenerRequest {
  return { filters: undefined, queryExpression: undefined, sort: undefined, fields: [], maxSize: 0 };
}

export const ScanScreenerRequest = {
  encode(message: ScanScreenerRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.filters !== undefined) {
      Filters.encode(message.filters, writer.uint32(10).fork()).ldelim();
    }
    if (message.queryExpression !== undefined) {
      writer.uint32(18).string(message.queryExpression);
    }
    if (message.sort !== undefined) {
      SortBy.encode(message.sort, writer.uint32(50).fork()).ldelim();
    }
    for (const v of message.fields) {
      writer.uint32(66).string(v!);
    }
    if (message.maxSize !== 0) {
      writer.uint32(80).int32(message.maxSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScanScreenerRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanScreenerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.filters = Filters.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.queryExpression = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.sort = SortBy.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.fields.push(reader.string());
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.maxSize = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScanScreenerRequest {
    return {
      filters: isSet(object.filters) ? Filters.fromJSON(object.filters) : undefined,
      queryExpression: isSet(object.queryExpression) ? globalThis.String(object.queryExpression) : undefined,
      sort: isSet(object.sort) ? SortBy.fromJSON(object.sort) : undefined,
      fields: globalThis.Array.isArray(object?.fields) ? object.fields.map((e: any) => globalThis.String(e)) : [],
      maxSize: isSet(object.maxSize) ? globalThis.Number(object.maxSize) : 0,
    };
  },

  toJSON(message: ScanScreenerRequest): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = Filters.toJSON(message.filters);
    }
    if (message.queryExpression !== undefined) {
      obj.queryExpression = message.queryExpression;
    }
    if (message.sort !== undefined) {
      obj.sort = SortBy.toJSON(message.sort);
    }
    if (message.fields?.length) {
      obj.fields = message.fields;
    }
    if (message.maxSize !== 0) {
      obj.maxSize = Math.round(message.maxSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanScreenerRequest>, I>>(base?: I): ScanScreenerRequest {
    return ScanScreenerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanScreenerRequest>, I>>(object: I): ScanScreenerRequest {
    const message = createBaseScanScreenerRequest();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? Filters.fromPartial(object.filters)
      : undefined;
    message.queryExpression = object.queryExpression ?? undefined;
    message.sort = (object.sort !== undefined && object.sort !== null) ? SortBy.fromPartial(object.sort) : undefined;
    message.fields = object.fields?.map((e) => e) || [];
    message.maxSize = object.maxSize ?? 0;
    return message;
  },
};

function createBaseAddToWatchlistRequest(): AddToWatchlistRequest {
  return { screenerId: "", watchlist: undefined };
}

export const AddToWatchlistRequest = {
  encode(message: AddToWatchlistRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.screenerId !== "") {
      writer.uint32(18).string(message.screenerId);
    }
    if (message.watchlist !== undefined) {
      Watchlist.encode(message.watchlist, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddToWatchlistRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddToWatchlistRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.screenerId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.watchlist = Watchlist.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddToWatchlistRequest {
    return {
      screenerId: isSet(object.screenerId) ? globalThis.String(object.screenerId) : "",
      watchlist: isSet(object.watchlist) ? Watchlist.fromJSON(object.watchlist) : undefined,
    };
  },

  toJSON(message: AddToWatchlistRequest): unknown {
    const obj: any = {};
    if (message.screenerId !== "") {
      obj.screenerId = message.screenerId;
    }
    if (message.watchlist !== undefined) {
      obj.watchlist = Watchlist.toJSON(message.watchlist);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddToWatchlistRequest>, I>>(base?: I): AddToWatchlistRequest {
    return AddToWatchlistRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddToWatchlistRequest>, I>>(object: I): AddToWatchlistRequest {
    const message = createBaseAddToWatchlistRequest();
    message.screenerId = object.screenerId ?? "";
    message.watchlist = (object.watchlist !== undefined && object.watchlist !== null)
      ? Watchlist.fromPartial(object.watchlist)
      : undefined;
    return message;
  },
};

function createBaseExportScreenerRequest(): ExportScreenerRequest {
  return { filters: undefined, queryExpression: undefined, sort: undefined, fields: [] };
}

export const ExportScreenerRequest = {
  encode(message: ExportScreenerRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.filters !== undefined) {
      Filters.encode(message.filters, writer.uint32(10).fork()).ldelim();
    }
    if (message.queryExpression !== undefined) {
      writer.uint32(18).string(message.queryExpression);
    }
    if (message.sort !== undefined) {
      SortBy.encode(message.sort, writer.uint32(50).fork()).ldelim();
    }
    for (const v of message.fields) {
      writer.uint32(66).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExportScreenerRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportScreenerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.filters = Filters.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.queryExpression = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.sort = SortBy.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.fields.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportScreenerRequest {
    return {
      filters: isSet(object.filters) ? Filters.fromJSON(object.filters) : undefined,
      queryExpression: isSet(object.queryExpression) ? globalThis.String(object.queryExpression) : undefined,
      sort: isSet(object.sort) ? SortBy.fromJSON(object.sort) : undefined,
      fields: globalThis.Array.isArray(object?.fields) ? object.fields.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ExportScreenerRequest): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = Filters.toJSON(message.filters);
    }
    if (message.queryExpression !== undefined) {
      obj.queryExpression = message.queryExpression;
    }
    if (message.sort !== undefined) {
      obj.sort = SortBy.toJSON(message.sort);
    }
    if (message.fields?.length) {
      obj.fields = message.fields;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportScreenerRequest>, I>>(base?: I): ExportScreenerRequest {
    return ExportScreenerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportScreenerRequest>, I>>(object: I): ExportScreenerRequest {
    const message = createBaseExportScreenerRequest();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? Filters.fromPartial(object.filters)
      : undefined;
    message.queryExpression = object.queryExpression ?? undefined;
    message.sort = (object.sort !== undefined && object.sort !== null) ? SortBy.fromPartial(object.sort) : undefined;
    message.fields = object.fields?.map((e) => e) || [];
    return message;
  },
};

function createBaseExportScreenerResponse(): ExportScreenerResponse {
  return { data: [] };
}

export const ExportScreenerResponse = {
  encode(message: ExportScreenerResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.data) {
      ScanScreenerResponse_ScreenerSecurityData.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExportScreenerResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportScreenerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.data.push(ScanScreenerResponse_ScreenerSecurityData.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportScreenerResponse {
    return {
      data: globalThis.Array.isArray(object?.data)
        ? object.data.map((e: any) => ScanScreenerResponse_ScreenerSecurityData.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ExportScreenerResponse): unknown {
    const obj: any = {};
    if (message.data?.length) {
      obj.data = message.data.map((e) => ScanScreenerResponse_ScreenerSecurityData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportScreenerResponse>, I>>(base?: I): ExportScreenerResponse {
    return ExportScreenerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportScreenerResponse>, I>>(object: I): ExportScreenerResponse {
    const message = createBaseExportScreenerResponse();
    message.data = object.data?.map((e) => ScanScreenerResponse_ScreenerSecurityData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScanScreenerResponse(): ScanScreenerResponse {
  return { data: [], totalCount: 0 };
}

export const ScanScreenerResponse = {
  encode(message: ScanScreenerResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.data) {
      ScanScreenerResponse_ScreenerSecurityData.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.totalCount !== 0) {
      writer.uint32(16).int32(message.totalCount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScanScreenerResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanScreenerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.data.push(ScanScreenerResponse_ScreenerSecurityData.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.totalCount = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScanScreenerResponse {
    return {
      data: globalThis.Array.isArray(object?.data)
        ? object.data.map((e: any) => ScanScreenerResponse_ScreenerSecurityData.fromJSON(e))
        : [],
      totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
    };
  },

  toJSON(message: ScanScreenerResponse): unknown {
    const obj: any = {};
    if (message.data?.length) {
      obj.data = message.data.map((e) => ScanScreenerResponse_ScreenerSecurityData.toJSON(e));
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanScreenerResponse>, I>>(base?: I): ScanScreenerResponse {
    return ScanScreenerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanScreenerResponse>, I>>(object: I): ScanScreenerResponse {
    const message = createBaseScanScreenerResponse();
    message.data = object.data?.map((e) => ScanScreenerResponse_ScreenerSecurityData.fromPartial(e)) || [];
    message.totalCount = object.totalCount ?? 0;
    return message;
  },
};

function createBaseScanScreenerResponse_ScreenerSecurityData(): ScanScreenerResponse_ScreenerSecurityData {
  return { exchange: 0, code: "", data: [] };
}

export const ScanScreenerResponse_ScreenerSecurityData = {
  encode(message: ScanScreenerResponse_ScreenerSecurityData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    for (const v of message.data) {
      writer.uint32(82).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScanScreenerResponse_ScreenerSecurityData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanScreenerResponse_ScreenerSecurityData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.data.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScanScreenerResponse_ScreenerSecurityData {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      data: globalThis.Array.isArray(object?.data) ? object.data.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ScanScreenerResponse_ScreenerSecurityData): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.data?.length) {
      obj.data = message.data;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanScreenerResponse_ScreenerSecurityData>, I>>(
    base?: I,
  ): ScanScreenerResponse_ScreenerSecurityData {
    return ScanScreenerResponse_ScreenerSecurityData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanScreenerResponse_ScreenerSecurityData>, I>>(
    object: I,
  ): ScanScreenerResponse_ScreenerSecurityData {
    const message = createBaseScanScreenerResponse_ScreenerSecurityData();
    message.exchange = object.exchange ?? 0;
    message.code = object.code ?? "";
    message.data = object.data?.map((e) => e) || [];
    return message;
  },
};

function createBaseScreenerField(): ScreenerField {
  return { code: "", dataType: 0, fieldType: 0, abbreviate: false, precision: 0, parameters: [] };
}

export const ScreenerField = {
  encode(message: ScreenerField, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.dataType !== 0) {
      writer.uint32(16).int32(message.dataType);
    }
    if (message.fieldType !== 0) {
      writer.uint32(24).int32(message.fieldType);
    }
    if (message.abbreviate !== false) {
      writer.uint32(32).bool(message.abbreviate);
    }
    if (message.precision !== 0) {
      writer.uint32(40).int32(message.precision);
    }
    for (const v of message.parameters) {
      FieldParameter.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerField {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerField();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.dataType = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.fieldType = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.abbreviate = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.precision = reader.int32();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.parameters.push(FieldParameter.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerField {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      dataType: isSet(object.dataType) ? dataTypeFromJSON(object.dataType) : 0,
      fieldType: isSet(object.fieldType) ? fieldTypeFromJSON(object.fieldType) : 0,
      abbreviate: isSet(object.abbreviate) ? globalThis.Boolean(object.abbreviate) : false,
      precision: isSet(object.precision) ? globalThis.Number(object.precision) : 0,
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FieldParameter.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScreenerField): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.dataType !== 0) {
      obj.dataType = dataTypeToJSON(message.dataType);
    }
    if (message.fieldType !== 0) {
      obj.fieldType = fieldTypeToJSON(message.fieldType);
    }
    if (message.abbreviate !== false) {
      obj.abbreviate = message.abbreviate;
    }
    if (message.precision !== 0) {
      obj.precision = Math.round(message.precision);
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FieldParameter.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerField>, I>>(base?: I): ScreenerField {
    return ScreenerField.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerField>, I>>(object: I): ScreenerField {
    const message = createBaseScreenerField();
    message.code = object.code ?? "";
    message.dataType = object.dataType ?? 0;
    message.fieldType = object.fieldType ?? 0;
    message.abbreviate = object.abbreviate ?? false;
    message.precision = object.precision ?? 0;
    message.parameters = object.parameters?.map((e) => FieldParameter.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScreenerFields(): ScreenerFields {
  return { fields: [] };
}

export const ScreenerFields = {
  encode(message: ScreenerFields, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.fields) {
      ScreenerField.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerFields {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerFields();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.fields.push(ScreenerField.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerFields {
    return {
      fields: globalThis.Array.isArray(object?.fields) ? object.fields.map((e: any) => ScreenerField.fromJSON(e)) : [],
    };
  },

  toJSON(message: ScreenerFields): unknown {
    const obj: any = {};
    if (message.fields?.length) {
      obj.fields = message.fields.map((e) => ScreenerField.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerFields>, I>>(base?: I): ScreenerFields {
    return ScreenerFields.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerFields>, I>>(object: I): ScreenerFields {
    const message = createBaseScreenerFields();
    message.fields = object.fields?.map((e) => ScreenerField.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScreenerFeedbackRequest(): ScreenerFeedbackRequest {
  return { feedback: [] };
}

export const ScreenerFeedbackRequest = {
  encode(message: ScreenerFeedbackRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.feedback) {
      Feedback.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerFeedbackRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerFeedbackRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.feedback.push(Feedback.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerFeedbackRequest {
    return {
      feedback: globalThis.Array.isArray(object?.feedback) ? object.feedback.map((e: any) => Feedback.fromJSON(e)) : [],
    };
  },

  toJSON(message: ScreenerFeedbackRequest): unknown {
    const obj: any = {};
    if (message.feedback?.length) {
      obj.feedback = message.feedback.map((e) => Feedback.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerFeedbackRequest>, I>>(base?: I): ScreenerFeedbackRequest {
    return ScreenerFeedbackRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerFeedbackRequest>, I>>(object: I): ScreenerFeedbackRequest {
    const message = createBaseScreenerFeedbackRequest();
    message.feedback = object.feedback?.map((e) => Feedback.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFeedback(): Feedback {
  return { query: "", generatedFilters: [], updatedFilters: [] };
}

export const Feedback = {
  encode(message: Feedback, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.query !== "") {
      writer.uint32(10).string(message.query);
    }
    for (const v of message.generatedFilters) {
      ScreenerFilter.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.updatedFilters) {
      ScreenerFilter.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Feedback {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeedback();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.query = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.generatedFilters.push(ScreenerFilter.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.updatedFilters.push(ScreenerFilter.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Feedback {
    return {
      query: isSet(object.query) ? globalThis.String(object.query) : "",
      generatedFilters: globalThis.Array.isArray(object?.generatedFilters)
        ? object.generatedFilters.map((e: any) => ScreenerFilter.fromJSON(e))
        : [],
      updatedFilters: globalThis.Array.isArray(object?.updatedFilters)
        ? object.updatedFilters.map((e: any) => ScreenerFilter.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Feedback): unknown {
    const obj: any = {};
    if (message.query !== "") {
      obj.query = message.query;
    }
    if (message.generatedFilters?.length) {
      obj.generatedFilters = message.generatedFilters.map((e) => ScreenerFilter.toJSON(e));
    }
    if (message.updatedFilters?.length) {
      obj.updatedFilters = message.updatedFilters.map((e) => ScreenerFilter.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Feedback>, I>>(base?: I): Feedback {
    return Feedback.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Feedback>, I>>(object: I): Feedback {
    const message = createBaseFeedback();
    message.query = object.query ?? "";
    message.generatedFilters = object.generatedFilters?.map((e) => ScreenerFilter.fromPartial(e)) || [];
    message.updatedFilters = object.updatedFilters?.map((e) => ScreenerFilter.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSubscriptionList(): SubscriptionList {
  return { screenerIds: [] };
}

export const SubscriptionList = {
  encode(message: SubscriptionList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.screenerIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubscriptionList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.screenerIds.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionList {
    return {
      screenerIds: globalThis.Array.isArray(object?.screenerIds)
        ? object.screenerIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SubscriptionList): unknown {
    const obj: any = {};
    if (message.screenerIds?.length) {
      obj.screenerIds = message.screenerIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionList>, I>>(base?: I): SubscriptionList {
    return SubscriptionList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionList>, I>>(object: I): SubscriptionList {
    const message = createBaseSubscriptionList();
    message.screenerIds = object.screenerIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseUpdateSubscriptionRequest(): UpdateSubscriptionRequest {
  return {
    screenerId: "",
    subscribe: false,
    userId: undefined,
    frequency: undefined,
    emailSendTime: undefined,
    notificationChannel: undefined,
  };
}

export const UpdateSubscriptionRequest = {
  encode(message: UpdateSubscriptionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.screenerId !== "") {
      writer.uint32(10).string(message.screenerId);
    }
    if (message.subscribe !== false) {
      writer.uint32(16).bool(message.subscribe);
    }
    if (message.userId !== undefined) {
      writer.uint32(26).string(message.userId);
    }
    if (message.frequency !== undefined) {
      writer.uint32(32).int32(message.frequency);
    }
    if (message.emailSendTime !== undefined) {
      writer.uint32(40).int32(message.emailSendTime);
    }
    if (message.notificationChannel !== undefined) {
      writer.uint32(48).int32(message.notificationChannel);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateSubscriptionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSubscriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.screenerId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.subscribe = reader.bool();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.frequency = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.emailSendTime = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.notificationChannel = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSubscriptionRequest {
    return {
      screenerId: isSet(object.screenerId) ? globalThis.String(object.screenerId) : "",
      subscribe: isSet(object.subscribe) ? globalThis.Boolean(object.subscribe) : false,
      userId: isSet(object.userId) ? globalThis.String(object.userId) : undefined,
      frequency: isSet(object.frequency) ? screenerEmailFrequencyFromJSON(object.frequency) : undefined,
      emailSendTime: isSet(object.emailSendTime) ? screenerEmailTimeFromJSON(object.emailSendTime) : undefined,
      notificationChannel: isSet(object.notificationChannel)
        ? notificationChannelFromJSON(object.notificationChannel)
        : undefined,
    };
  },

  toJSON(message: UpdateSubscriptionRequest): unknown {
    const obj: any = {};
    if (message.screenerId !== "") {
      obj.screenerId = message.screenerId;
    }
    if (message.subscribe !== false) {
      obj.subscribe = message.subscribe;
    }
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    if (message.frequency !== undefined) {
      obj.frequency = screenerEmailFrequencyToJSON(message.frequency);
    }
    if (message.emailSendTime !== undefined) {
      obj.emailSendTime = screenerEmailTimeToJSON(message.emailSendTime);
    }
    if (message.notificationChannel !== undefined) {
      obj.notificationChannel = notificationChannelToJSON(message.notificationChannel);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSubscriptionRequest>, I>>(base?: I): UpdateSubscriptionRequest {
    return UpdateSubscriptionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSubscriptionRequest>, I>>(object: I): UpdateSubscriptionRequest {
    const message = createBaseUpdateSubscriptionRequest();
    message.screenerId = object.screenerId ?? "";
    message.subscribe = object.subscribe ?? false;
    message.userId = object.userId ?? undefined;
    message.frequency = object.frequency ?? undefined;
    message.emailSendTime = object.emailSendTime ?? undefined;
    message.notificationChannel = object.notificationChannel ?? undefined;
    return message;
  },
};

function createBaseCustomScreenerColumnRequest(): CustomScreenerColumnRequest {
  return { userId: undefined, screenerColumn: "" };
}

export const CustomScreenerColumnRequest = {
  encode(message: CustomScreenerColumnRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== undefined) {
      writer.uint32(10).string(message.userId);
    }
    if (message.screenerColumn !== "") {
      writer.uint32(18).string(message.screenerColumn);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CustomScreenerColumnRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomScreenerColumnRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.screenerColumn = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomScreenerColumnRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : undefined,
      screenerColumn: isSet(object.screenerColumn) ? globalThis.String(object.screenerColumn) : "",
    };
  },

  toJSON(message: CustomScreenerColumnRequest): unknown {
    const obj: any = {};
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    if (message.screenerColumn !== "") {
      obj.screenerColumn = message.screenerColumn;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CustomScreenerColumnRequest>, I>>(base?: I): CustomScreenerColumnRequest {
    return CustomScreenerColumnRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomScreenerColumnRequest>, I>>(object: I): CustomScreenerColumnRequest {
    const message = createBaseCustomScreenerColumnRequest();
    message.userId = object.userId ?? undefined;
    message.screenerColumn = object.screenerColumn ?? "";
    return message;
  },
};

function createBaseCustomScreenColumn(): CustomScreenColumn {
  return { screenerColumn: "", id: "" };
}

export const CustomScreenColumn = {
  encode(message: CustomScreenColumn, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.screenerColumn !== "") {
      writer.uint32(10).string(message.screenerColumn);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CustomScreenColumn {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomScreenColumn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.screenerColumn = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomScreenColumn {
    return {
      screenerColumn: isSet(object.screenerColumn) ? globalThis.String(object.screenerColumn) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: CustomScreenColumn): unknown {
    const obj: any = {};
    if (message.screenerColumn !== "") {
      obj.screenerColumn = message.screenerColumn;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CustomScreenColumn>, I>>(base?: I): CustomScreenColumn {
    return CustomScreenColumn.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomScreenColumn>, I>>(object: I): CustomScreenColumn {
    const message = createBaseCustomScreenColumn();
    message.screenerColumn = object.screenerColumn ?? "";
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseDeleteScreenerCustomColumnRequest(): DeleteScreenerCustomColumnRequest {
  return { userId: undefined, id: "" };
}

export const DeleteScreenerCustomColumnRequest = {
  encode(message: DeleteScreenerCustomColumnRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== undefined) {
      writer.uint32(10).string(message.userId);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteScreenerCustomColumnRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteScreenerCustomColumnRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteScreenerCustomColumnRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: DeleteScreenerCustomColumnRequest): unknown {
    const obj: any = {};
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteScreenerCustomColumnRequest>, I>>(
    base?: I,
  ): DeleteScreenerCustomColumnRequest {
    return DeleteScreenerCustomColumnRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteScreenerCustomColumnRequest>, I>>(
    object: I,
  ): DeleteScreenerCustomColumnRequest {
    const message = createBaseDeleteScreenerCustomColumnRequest();
    message.userId = object.userId ?? undefined;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseCustomScreenerColumns(): CustomScreenerColumns {
  return { columns: [] };
}

export const CustomScreenerColumns = {
  encode(message: CustomScreenerColumns, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.columns) {
      CustomScreenColumn.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CustomScreenerColumns {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomScreenerColumns();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.columns.push(CustomScreenColumn.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomScreenerColumns {
    return {
      columns: globalThis.Array.isArray(object?.columns)
        ? object.columns.map((e: any) => CustomScreenColumn.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CustomScreenerColumns): unknown {
    const obj: any = {};
    if (message.columns?.length) {
      obj.columns = message.columns.map((e) => CustomScreenColumn.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CustomScreenerColumns>, I>>(base?: I): CustomScreenerColumns {
    return CustomScreenerColumns.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomScreenerColumns>, I>>(object: I): CustomScreenerColumns {
    const message = createBaseCustomScreenerColumns();
    message.columns = object.columns?.map((e) => CustomScreenColumn.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScreenerColumnMetadata(): ScreenerColumnMetadata {
  return {
    columnCode: "",
    fieldCode: "",
    displayName: "",
    isNumeric: false,
    precision: 0,
    fieldType: undefined,
    abbreviate: false,
    dataType: 0,
  };
}

export const ScreenerColumnMetadata = {
  encode(message: ScreenerColumnMetadata, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.columnCode !== "") {
      writer.uint32(10).string(message.columnCode);
    }
    if (message.fieldCode !== "") {
      writer.uint32(18).string(message.fieldCode);
    }
    if (message.displayName !== "") {
      writer.uint32(26).string(message.displayName);
    }
    if (message.isNumeric !== false) {
      writer.uint32(32).bool(message.isNumeric);
    }
    if (message.precision !== 0) {
      writer.uint32(40).int32(message.precision);
    }
    if (message.fieldType !== undefined) {
      writer.uint32(48).int32(message.fieldType);
    }
    if (message.abbreviate !== false) {
      writer.uint32(56).bool(message.abbreviate);
    }
    if (message.dataType !== 0) {
      writer.uint32(64).int32(message.dataType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerColumnMetadata {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerColumnMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.columnCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.fieldCode = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isNumeric = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.precision = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.fieldType = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.abbreviate = reader.bool();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.dataType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerColumnMetadata {
    return {
      columnCode: isSet(object.columnCode) ? globalThis.String(object.columnCode) : "",
      fieldCode: isSet(object.fieldCode) ? globalThis.String(object.fieldCode) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      isNumeric: isSet(object.isNumeric) ? globalThis.Boolean(object.isNumeric) : false,
      precision: isSet(object.precision) ? globalThis.Number(object.precision) : 0,
      fieldType: isSet(object.fieldType) ? fieldTypeFromJSON(object.fieldType) : undefined,
      abbreviate: isSet(object.abbreviate) ? globalThis.Boolean(object.abbreviate) : false,
      dataType: isSet(object.dataType) ? dataTypeFromJSON(object.dataType) : 0,
    };
  },

  toJSON(message: ScreenerColumnMetadata): unknown {
    const obj: any = {};
    if (message.columnCode !== "") {
      obj.columnCode = message.columnCode;
    }
    if (message.fieldCode !== "") {
      obj.fieldCode = message.fieldCode;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.isNumeric !== false) {
      obj.isNumeric = message.isNumeric;
    }
    if (message.precision !== 0) {
      obj.precision = Math.round(message.precision);
    }
    if (message.fieldType !== undefined) {
      obj.fieldType = fieldTypeToJSON(message.fieldType);
    }
    if (message.abbreviate !== false) {
      obj.abbreviate = message.abbreviate;
    }
    if (message.dataType !== 0) {
      obj.dataType = dataTypeToJSON(message.dataType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerColumnMetadata>, I>>(base?: I): ScreenerColumnMetadata {
    return ScreenerColumnMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerColumnMetadata>, I>>(object: I): ScreenerColumnMetadata {
    const message = createBaseScreenerColumnMetadata();
    message.columnCode = object.columnCode ?? "";
    message.fieldCode = object.fieldCode ?? "";
    message.displayName = object.displayName ?? "";
    message.isNumeric = object.isNumeric ?? false;
    message.precision = object.precision ?? 0;
    message.fieldType = object.fieldType ?? undefined;
    message.abbreviate = object.abbreviate ?? false;
    message.dataType = object.dataType ?? 0;
    return message;
  },
};

function createBaseSecurityScreenerMetaDataResponse(): SecurityScreenerMetaDataResponse {
  return { columnMetadata: [] };
}

export const SecurityScreenerMetaDataResponse = {
  encode(message: SecurityScreenerMetaDataResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.columnMetadata) {
      ScreenerColumnMetadata.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecurityScreenerMetaDataResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurityScreenerMetaDataResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.columnMetadata.push(ScreenerColumnMetadata.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecurityScreenerMetaDataResponse {
    return {
      columnMetadata: globalThis.Array.isArray(object?.columnMetadata)
        ? object.columnMetadata.map((e: any) => ScreenerColumnMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SecurityScreenerMetaDataResponse): unknown {
    const obj: any = {};
    if (message.columnMetadata?.length) {
      obj.columnMetadata = message.columnMetadata.map((e) => ScreenerColumnMetadata.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecurityScreenerMetaDataResponse>, I>>(
    base?: I,
  ): SecurityScreenerMetaDataResponse {
    return SecurityScreenerMetaDataResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecurityScreenerMetaDataResponse>, I>>(
    object: I,
  ): SecurityScreenerMetaDataResponse {
    const message = createBaseSecurityScreenerMetaDataResponse();
    message.columnMetadata = object.columnMetadata?.map((e) => ScreenerColumnMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScreenerSubscriptionDataRequest(): ScreenerSubscriptionDataRequest {
  return { userId: "", email: "", name: "", data: [] };
}

export const ScreenerSubscriptionDataRequest = {
  encode(message: ScreenerSubscriptionDataRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    for (const v of message.data) {
      ScreenData.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenerSubscriptionDataRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenerSubscriptionDataRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.data.push(ScreenData.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenerSubscriptionDataRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      data: globalThis.Array.isArray(object?.data) ? object.data.map((e: any) => ScreenData.fromJSON(e)) : [],
    };
  },

  toJSON(message: ScreenerSubscriptionDataRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => ScreenData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenerSubscriptionDataRequest>, I>>(base?: I): ScreenerSubscriptionDataRequest {
    return ScreenerSubscriptionDataRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerSubscriptionDataRequest>, I>>(
    object: I,
  ): ScreenerSubscriptionDataRequest {
    const message = createBaseScreenerSubscriptionDataRequest();
    message.userId = object.userId ?? "";
    message.email = object.email ?? "";
    message.name = object.name ?? "";
    message.data = object.data?.map((e) => ScreenData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScreenData(): ScreenData {
  return { screenerLayout: undefined, filters: undefined, sortBy: undefined };
}

export const ScreenData = {
  encode(message: ScreenData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.screenerLayout !== undefined) {
      UserScreenerLayout.encode(message.screenerLayout, writer.uint32(34).fork()).ldelim();
    }
    if (message.filters !== undefined) {
      Filters.encode(message.filters, writer.uint32(42).fork()).ldelim();
    }
    if (message.sortBy !== undefined) {
      SortBy.encode(message.sortBy, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScreenData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScreenData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          if (tag !== 34) {
            break;
          }

          message.screenerLayout = UserScreenerLayout.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.filters = Filters.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.sortBy = SortBy.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScreenData {
    return {
      screenerLayout: isSet(object.screenerLayout) ? UserScreenerLayout.fromJSON(object.screenerLayout) : undefined,
      filters: isSet(object.filters) ? Filters.fromJSON(object.filters) : undefined,
      sortBy: isSet(object.sortBy) ? SortBy.fromJSON(object.sortBy) : undefined,
    };
  },

  toJSON(message: ScreenData): unknown {
    const obj: any = {};
    if (message.screenerLayout !== undefined) {
      obj.screenerLayout = UserScreenerLayout.toJSON(message.screenerLayout);
    }
    if (message.filters !== undefined) {
      obj.filters = Filters.toJSON(message.filters);
    }
    if (message.sortBy !== undefined) {
      obj.sortBy = SortBy.toJSON(message.sortBy);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScreenData>, I>>(base?: I): ScreenData {
    return ScreenData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScreenData>, I>>(object: I): ScreenData {
    const message = createBaseScreenData();
    message.screenerLayout = (object.screenerLayout !== undefined && object.screenerLayout !== null)
      ? UserScreenerLayout.fromPartial(object.screenerLayout)
      : undefined;
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? Filters.fromPartial(object.filters)
      : undefined;
    message.sortBy = (object.sortBy !== undefined && object.sortBy !== null)
      ? SortBy.fromPartial(object.sortBy)
      : undefined;
    return message;
  },
};

function createBaseSendScreenerEmailRequest(): SendScreenerEmailRequest {
  return { email: "", name: "", screenerId: "" };
}

export const SendScreenerEmailRequest = {
  encode(message: SendScreenerEmailRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.screenerId !== "") {
      writer.uint32(26).string(message.screenerId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendScreenerEmailRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendScreenerEmailRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.screenerId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendScreenerEmailRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      screenerId: isSet(object.screenerId) ? globalThis.String(object.screenerId) : "",
    };
  },

  toJSON(message: SendScreenerEmailRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.screenerId !== "") {
      obj.screenerId = message.screenerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendScreenerEmailRequest>, I>>(base?: I): SendScreenerEmailRequest {
    return SendScreenerEmailRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendScreenerEmailRequest>, I>>(object: I): SendScreenerEmailRequest {
    const message = createBaseSendScreenerEmailRequest();
    message.email = object.email ?? "";
    message.name = object.name ?? "";
    message.screenerId = object.screenerId ?? "";
    return message;
  },
};

export interface ScreenerService {
  GetScreenerConfiguration(request: Empty): Promise<ScreenerConfiguration>;
  ScanScreener(request: ScanScreenerRequest): Promise<ScanScreenerResponse>;
  ExportScreener(request: ExportScreenerRequest): Promise<ExportScreenerResponse>;
  GenerateFilters(request: StringValue): Promise<Filters>;
  SaveScreenerFeedback(request: ScreenerFeedbackRequest): Promise<Empty>;
  GetScreenerWatchlistItems(request: GetScreenerWatchlistItemsRequest): Promise<WatchlistItems>;
  CreateScreenerCustomColumn(request: CustomScreenerColumnRequest): Promise<CustomScreenColumn>;
  GetScreenerCustomColumns(request: StringValue): Promise<CustomScreenerColumns>;
  DeleteScreenerCustomColumn(request: DeleteScreenerCustomColumnRequest): Promise<Empty>;
  SendScreenerEmail(request: SendScreenerEmailRequest): Promise<Empty>;
}

export const ScreenerServiceServiceName = "com.tick2trade.api.screener.ScreenerService";
export class ScreenerServiceClientImpl implements ScreenerService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || ScreenerServiceServiceName;
    this.rpc = rpc;
    this.GetScreenerConfiguration = this.GetScreenerConfiguration.bind(this);
    this.ScanScreener = this.ScanScreener.bind(this);
    this.ExportScreener = this.ExportScreener.bind(this);
    this.GenerateFilters = this.GenerateFilters.bind(this);
    this.SaveScreenerFeedback = this.SaveScreenerFeedback.bind(this);
    this.GetScreenerWatchlistItems = this.GetScreenerWatchlistItems.bind(this);
    this.CreateScreenerCustomColumn = this.CreateScreenerCustomColumn.bind(this);
    this.GetScreenerCustomColumns = this.GetScreenerCustomColumns.bind(this);
    this.DeleteScreenerCustomColumn = this.DeleteScreenerCustomColumn.bind(this);
    this.SendScreenerEmail = this.SendScreenerEmail.bind(this);
  }
  GetScreenerConfiguration(request: Empty): Promise<ScreenerConfiguration> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetScreenerConfiguration", data);
    return promise.then((data) => ScreenerConfiguration.decode(_m0.Reader.create(data)));
  }

  ScanScreener(request: ScanScreenerRequest): Promise<ScanScreenerResponse> {
    const data = ScanScreenerRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ScanScreener", data);
    return promise.then((data) => ScanScreenerResponse.decode(_m0.Reader.create(data)));
  }

  ExportScreener(request: ExportScreenerRequest): Promise<ExportScreenerResponse> {
    const data = ExportScreenerRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ExportScreener", data);
    return promise.then((data) => ExportScreenerResponse.decode(_m0.Reader.create(data)));
  }

  GenerateFilters(request: StringValue): Promise<Filters> {
    const data = StringValue.encode(request).finish();
    const promise = this.rpc.request(this.service, "GenerateFilters", data);
    return promise.then((data) => Filters.decode(_m0.Reader.create(data)));
  }

  SaveScreenerFeedback(request: ScreenerFeedbackRequest): Promise<Empty> {
    const data = ScreenerFeedbackRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SaveScreenerFeedback", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }

  GetScreenerWatchlistItems(request: GetScreenerWatchlistItemsRequest): Promise<WatchlistItems> {
    const data = GetScreenerWatchlistItemsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetScreenerWatchlistItems", data);
    return promise.then((data) => WatchlistItems.decode(_m0.Reader.create(data)));
  }

  CreateScreenerCustomColumn(request: CustomScreenerColumnRequest): Promise<CustomScreenColumn> {
    const data = CustomScreenerColumnRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CreateScreenerCustomColumn", data);
    return promise.then((data) => CustomScreenColumn.decode(_m0.Reader.create(data)));
  }

  GetScreenerCustomColumns(request: StringValue): Promise<CustomScreenerColumns> {
    const data = StringValue.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetScreenerCustomColumns", data);
    return promise.then((data) => CustomScreenerColumns.decode(_m0.Reader.create(data)));
  }

  DeleteScreenerCustomColumn(request: DeleteScreenerCustomColumnRequest): Promise<Empty> {
    const data = DeleteScreenerCustomColumnRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "DeleteScreenerCustomColumn", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }

  SendScreenerEmail(request: SendScreenerEmailRequest): Promise<Empty> {
    const data = SendScreenerEmailRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SendScreenerEmail", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

// ─── Heatmap types (appended — run proto-generator.sh to regenerate cleanly) ──

export enum HeatmapGroupBy {
  HEATMAP_GROUP_BY_UNKNOWN = 0,
  SECTOR = 1,
  NO_GROUP = 2,
  UNRECOGNIZED = -1,
}

export function heatmapGroupByFromJSON(object: any): HeatmapGroupBy {
  switch (object) {
    case 0:
    case "HEATMAP_GROUP_BY_UNKNOWN":
      return HeatmapGroupBy.HEATMAP_GROUP_BY_UNKNOWN;
    case 1:
    case "SECTOR":
      return HeatmapGroupBy.SECTOR;
    case 2:
    case "NO_GROUP":
      return HeatmapGroupBy.NO_GROUP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HeatmapGroupBy.UNRECOGNIZED;
  }
}

export function heatmapGroupByToJSON(object: HeatmapGroupBy): string {
  switch (object) {
    case HeatmapGroupBy.HEATMAP_GROUP_BY_UNKNOWN:
      return "HEATMAP_GROUP_BY_UNKNOWN";
    case HeatmapGroupBy.SECTOR:
      return "SECTOR";
    case HeatmapGroupBy.NO_GROUP:
      return "NO_GROUP";
    case HeatmapGroupBy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface HeatmapFieldOption {
  fieldCode: string;
  displayName: string;
}

export interface HeatmapConfiguration {
  supportedIndices: string[];
  defaultIndex: string;
  supportedGroupBy: HeatmapGroupBy[];
  sizeByOptions: HeatmapFieldOption[];
  defaultSizeBy: string;
  colorByOptions: HeatmapFieldOption[];
  defaultColorBy: string;
  supportedSectors: string[];
}

export interface HeatmapSecuritiesRequest {
  index?: string | undefined;
  groupBy: HeatmapGroupBy;
  sector?: string | undefined;
  sizeBy?: string | undefined;
  colorBy?: string | undefined;
}

export interface HeatmapSecurityGroup {
  groupName: string;
  securities: ScanScreenerResponse_ScreenerSecurityData[];
}

export interface HeatmapSecuritiesResponse {
  index: string;
  fields: string[];
  securities: ScanScreenerResponse_ScreenerSecurityData[];
  groups: HeatmapSecurityGroup[];
  sizeByField: string;
  colorByField: string;
}

function createBaseHeatmapFieldOption(): HeatmapFieldOption {
  return { fieldCode: "", displayName: "" };
}

export const HeatmapFieldOption = {
  encode(message: HeatmapFieldOption, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.fieldCode !== "") writer.uint32(10).string(message.fieldCode);
    if (message.displayName !== "") writer.uint32(18).string(message.displayName);
    return writer;
  },
  decode(input: _m0.Reader | Uint8Array, length?: number): HeatmapFieldOption {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeatmapFieldOption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: if (tag === 10) { message.fieldCode = reader.string(); continue; } break;
        case 2: if (tag === 18) { message.displayName = reader.string(); continue; } break;
      }
      if ((tag & 7) === 4 || tag === 0) break;
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON(object: any): HeatmapFieldOption {
    return {
      fieldCode: isSet(object.fieldCode) ? globalThis.String(object.fieldCode) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
    };
  },
  toJSON(message: HeatmapFieldOption): unknown {
    const obj: any = {};
    if (message.fieldCode !== "") obj.fieldCode = message.fieldCode;
    if (message.displayName !== "") obj.displayName = message.displayName;
    return obj;
  },
  create<I extends Exact<DeepPartial<HeatmapFieldOption>, I>>(base?: I): HeatmapFieldOption {
    return HeatmapFieldOption.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HeatmapFieldOption>, I>>(object: I): HeatmapFieldOption {
    const message = createBaseHeatmapFieldOption();
    message.fieldCode = object.fieldCode ?? "";
    message.displayName = object.displayName ?? "";
    return message;
  },
};

function createBaseHeatmapConfiguration(): HeatmapConfiguration {
  return { supportedIndices: [], defaultIndex: "", supportedGroupBy: [], sizeByOptions: [], defaultSizeBy: "", colorByOptions: [], defaultColorBy: "", supportedSectors: [] };
}

export const HeatmapConfiguration = {
  encode(message: HeatmapConfiguration, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.supportedIndices) writer.uint32(10).string(v!);
    if (message.defaultIndex !== "") writer.uint32(18).string(message.defaultIndex);
    writer.uint32(26).fork();
    for (const v of message.supportedGroupBy) writer.int32(v);
    writer.ldelim();
    for (const v of message.sizeByOptions) HeatmapFieldOption.encode(v!, writer.uint32(34).fork()).ldelim();
    if (message.defaultSizeBy !== "") writer.uint32(42).string(message.defaultSizeBy);
    for (const v of message.colorByOptions) HeatmapFieldOption.encode(v!, writer.uint32(50).fork()).ldelim();
    if (message.defaultColorBy !== "") writer.uint32(58).string(message.defaultColorBy);
    for (const v of message.supportedSectors) writer.uint32(66).string(v!);
    return writer;
  },
  decode(input: _m0.Reader | Uint8Array, length?: number): HeatmapConfiguration {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeatmapConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: if (tag === 10) { message.supportedIndices.push(reader.string()); continue; } break;
        case 2: if (tag === 18) { message.defaultIndex = reader.string(); continue; } break;
        case 3:
          if (tag === 24) { message.supportedGroupBy.push(reader.int32() as any); continue; }
          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) message.supportedGroupBy.push(reader.int32() as any);
            continue;
          }
          break;
        case 4: if (tag === 34) { message.sizeByOptions.push(HeatmapFieldOption.decode(reader, reader.uint32())); continue; } break;
        case 5: if (tag === 42) { message.defaultSizeBy = reader.string(); continue; } break;
        case 6: if (tag === 50) { message.colorByOptions.push(HeatmapFieldOption.decode(reader, reader.uint32())); continue; } break;
        case 7: if (tag === 58) { message.defaultColorBy = reader.string(); continue; } break;
        case 8: if (tag === 66) { message.supportedSectors.push(reader.string()); continue; } break;
      }
      if ((tag & 7) === 4 || tag === 0) break;
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON(object: any): HeatmapConfiguration {
    return {
      supportedIndices: globalThis.Array.isArray(object?.supportedIndices) ? object.supportedIndices.map((e: any) => globalThis.String(e)) : [],
      defaultIndex: isSet(object.defaultIndex) ? globalThis.String(object.defaultIndex) : "",
      supportedGroupBy: globalThis.Array.isArray(object?.supportedGroupBy) ? object.supportedGroupBy.map((e: any) => heatmapGroupByFromJSON(e)) : [],
      sizeByOptions: globalThis.Array.isArray(object?.sizeByOptions) ? object.sizeByOptions.map((e: any) => HeatmapFieldOption.fromJSON(e)) : [],
      defaultSizeBy: isSet(object.defaultSizeBy) ? globalThis.String(object.defaultSizeBy) : "",
      colorByOptions: globalThis.Array.isArray(object?.colorByOptions) ? object.colorByOptions.map((e: any) => HeatmapFieldOption.fromJSON(e)) : [],
      defaultColorBy: isSet(object.defaultColorBy) ? globalThis.String(object.defaultColorBy) : "",
      supportedSectors: globalThis.Array.isArray(object?.supportedSectors) ? object.supportedSectors.map((e: any) => globalThis.String(e)) : [],
    };
  },
  toJSON(message: HeatmapConfiguration): unknown {
    const obj: any = {};
    if (message.supportedIndices?.length) obj.supportedIndices = message.supportedIndices;
    if (message.defaultIndex !== "") obj.defaultIndex = message.defaultIndex;
    if (message.supportedGroupBy?.length) obj.supportedGroupBy = message.supportedGroupBy.map((e) => heatmapGroupByToJSON(e));
    if (message.sizeByOptions?.length) obj.sizeByOptions = message.sizeByOptions.map((e) => HeatmapFieldOption.toJSON(e));
    if (message.defaultSizeBy !== "") obj.defaultSizeBy = message.defaultSizeBy;
    if (message.colorByOptions?.length) obj.colorByOptions = message.colorByOptions.map((e) => HeatmapFieldOption.toJSON(e));
    if (message.defaultColorBy !== "") obj.defaultColorBy = message.defaultColorBy;
    if (message.supportedSectors?.length) obj.supportedSectors = message.supportedSectors;
    return obj;
  },
  create<I extends Exact<DeepPartial<HeatmapConfiguration>, I>>(base?: I): HeatmapConfiguration {
    return HeatmapConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HeatmapConfiguration>, I>>(object: I): HeatmapConfiguration {
    const message = createBaseHeatmapConfiguration();
    message.supportedIndices = object.supportedIndices?.map((e) => e) ?? [];
    message.defaultIndex = object.defaultIndex ?? "";
    message.supportedGroupBy = object.supportedGroupBy?.map((e) => e) ?? [];
    message.sizeByOptions = object.sizeByOptions?.map((e) => HeatmapFieldOption.fromPartial(e)) ?? [];
    message.defaultSizeBy = object.defaultSizeBy ?? "";
    message.colorByOptions = object.colorByOptions?.map((e) => HeatmapFieldOption.fromPartial(e)) ?? [];
    message.defaultColorBy = object.defaultColorBy ?? "";
    message.supportedSectors = object.supportedSectors?.map((e) => e) ?? [];
    return message;
  },
};

function createBaseHeatmapSecuritiesRequest(): HeatmapSecuritiesRequest {
  return { groupBy: 0 };
}

export const HeatmapSecuritiesRequest = {
  encode(message: HeatmapSecuritiesRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.index !== undefined) writer.uint32(10).string(message.index);
    if (message.groupBy !== 0) writer.uint32(16).int32(message.groupBy);
    if (message.sector !== undefined) writer.uint32(26).string(message.sector);
    if (message.sizeBy !== undefined) writer.uint32(34).string(message.sizeBy);
    if (message.colorBy !== undefined) writer.uint32(42).string(message.colorBy);
    return writer;
  },
  decode(input: _m0.Reader | Uint8Array, length?: number): HeatmapSecuritiesRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeatmapSecuritiesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: if (tag === 10) { message.index = reader.string(); continue; } break;
        case 2: if (tag === 16) { message.groupBy = reader.int32() as any; continue; } break;
        case 3: if (tag === 26) { message.sector = reader.string(); continue; } break;
        case 4: if (tag === 34) { message.sizeBy = reader.string(); continue; } break;
        case 5: if (tag === 42) { message.colorBy = reader.string(); continue; } break;
      }
      if ((tag & 7) === 4 || tag === 0) break;
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON(object: any): HeatmapSecuritiesRequest {
    return {
      index: isSet(object.index) ? globalThis.String(object.index) : undefined,
      groupBy: isSet(object.groupBy) ? heatmapGroupByFromJSON(object.groupBy) : 0,
      sector: isSet(object.sector) ? globalThis.String(object.sector) : undefined,
      sizeBy: isSet(object.sizeBy) ? globalThis.String(object.sizeBy) : undefined,
      colorBy: isSet(object.colorBy) ? globalThis.String(object.colorBy) : undefined,
    };
  },
  toJSON(message: HeatmapSecuritiesRequest): unknown {
    const obj: any = {};
    if (message.index !== undefined) obj.index = message.index;
    if (message.groupBy !== 0) obj.groupBy = heatmapGroupByToJSON(message.groupBy);
    if (message.sector !== undefined) obj.sector = message.sector;
    if (message.sizeBy !== undefined) obj.sizeBy = message.sizeBy;
    if (message.colorBy !== undefined) obj.colorBy = message.colorBy;
    return obj;
  },
  create<I extends Exact<DeepPartial<HeatmapSecuritiesRequest>, I>>(base?: I): HeatmapSecuritiesRequest {
    return HeatmapSecuritiesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HeatmapSecuritiesRequest>, I>>(object: I): HeatmapSecuritiesRequest {
    const message = createBaseHeatmapSecuritiesRequest();
    message.index = object.index ?? undefined;
    message.groupBy = object.groupBy ?? 0;
    message.sector = object.sector ?? undefined;
    message.sizeBy = object.sizeBy ?? undefined;
    message.colorBy = object.colorBy ?? undefined;
    return message;
  },
};

function createBaseHeatmapSecurityGroup(): HeatmapSecurityGroup {
  return { groupName: "", securities: [] };
}

export const HeatmapSecurityGroup = {
  encode(message: HeatmapSecurityGroup, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.groupName !== "") writer.uint32(10).string(message.groupName);
    for (const v of message.securities) ScanScreenerResponse_ScreenerSecurityData.encode(v!, writer.uint32(18).fork()).ldelim();
    return writer;
  },
  decode(input: _m0.Reader | Uint8Array, length?: number): HeatmapSecurityGroup {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeatmapSecurityGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: if (tag === 10) { message.groupName = reader.string(); continue; } break;
        case 2: if (tag === 18) { message.securities.push(ScanScreenerResponse_ScreenerSecurityData.decode(reader, reader.uint32())); continue; } break;
      }
      if ((tag & 7) === 4 || tag === 0) break;
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON(object: any): HeatmapSecurityGroup {
    return {
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : "",
      securities: globalThis.Array.isArray(object?.securities) ? object.securities.map((e: any) => ScanScreenerResponse_ScreenerSecurityData.fromJSON(e)) : [],
    };
  },
  toJSON(message: HeatmapSecurityGroup): unknown {
    const obj: any = {};
    if (message.groupName !== "") obj.groupName = message.groupName;
    if (message.securities?.length) obj.securities = message.securities.map((e) => ScanScreenerResponse_ScreenerSecurityData.toJSON(e));
    return obj;
  },
  create<I extends Exact<DeepPartial<HeatmapSecurityGroup>, I>>(base?: I): HeatmapSecurityGroup {
    return HeatmapSecurityGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HeatmapSecurityGroup>, I>>(object: I): HeatmapSecurityGroup {
    const message = createBaseHeatmapSecurityGroup();
    message.groupName = object.groupName ?? "";
    message.securities = object.securities?.map((e) => ScanScreenerResponse_ScreenerSecurityData.fromPartial(e)) ?? [];
    return message;
  },
};

function createBaseHeatmapSecuritiesResponse(): HeatmapSecuritiesResponse {
  return { index: "", fields: [], securities: [], groups: [], sizeByField: "", colorByField: "" };
}

export const HeatmapSecuritiesResponse = {
  encode(message: HeatmapSecuritiesResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.index !== "") writer.uint32(10).string(message.index);
    for (const v of message.fields) writer.uint32(18).string(v!);
    for (const v of message.securities) ScanScreenerResponse_ScreenerSecurityData.encode(v!, writer.uint32(26).fork()).ldelim();
    for (const v of message.groups) HeatmapSecurityGroup.encode(v!, writer.uint32(34).fork()).ldelim();
    if (message.sizeByField !== "") writer.uint32(42).string(message.sizeByField);
    if (message.colorByField !== "") writer.uint32(50).string(message.colorByField);
    return writer;
  },
  decode(input: _m0.Reader | Uint8Array, length?: number): HeatmapSecuritiesResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeatmapSecuritiesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: if (tag === 10) { message.index = reader.string(); continue; } break;
        case 2: if (tag === 18) { message.fields.push(reader.string()); continue; } break;
        case 3: if (tag === 26) { message.securities.push(ScanScreenerResponse_ScreenerSecurityData.decode(reader, reader.uint32())); continue; } break;
        case 4: if (tag === 34) { message.groups.push(HeatmapSecurityGroup.decode(reader, reader.uint32())); continue; } break;
        case 5: if (tag === 42) { message.sizeByField = reader.string(); continue; } break;
        case 6: if (tag === 50) { message.colorByField = reader.string(); continue; } break;
      }
      if ((tag & 7) === 4 || tag === 0) break;
      reader.skipType(tag & 7);
    }
    return message;
  },
  fromJSON(object: any): HeatmapSecuritiesResponse {
    return {
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      fields: globalThis.Array.isArray(object?.fields) ? object.fields.map((e: any) => globalThis.String(e)) : [],
      securities: globalThis.Array.isArray(object?.securities) ? object.securities.map((e: any) => ScanScreenerResponse_ScreenerSecurityData.fromJSON(e)) : [],
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => HeatmapSecurityGroup.fromJSON(e)) : [],
      sizeByField: isSet(object.sizeByField) ? globalThis.String(object.sizeByField) : "",
      colorByField: isSet(object.colorByField) ? globalThis.String(object.colorByField) : "",
    };
  },
  toJSON(message: HeatmapSecuritiesResponse): unknown {
    const obj: any = {};
    if (message.index !== "") obj.index = message.index;
    if (message.fields?.length) obj.fields = message.fields;
    if (message.securities?.length) obj.securities = message.securities.map((e) => ScanScreenerResponse_ScreenerSecurityData.toJSON(e));
    if (message.groups?.length) obj.groups = message.groups.map((e) => HeatmapSecurityGroup.toJSON(e));
    if (message.sizeByField !== "") obj.sizeByField = message.sizeByField;
    if (message.colorByField !== "") obj.colorByField = message.colorByField;
    return obj;
  },
  create<I extends Exact<DeepPartial<HeatmapSecuritiesResponse>, I>>(base?: I): HeatmapSecuritiesResponse {
    return HeatmapSecuritiesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HeatmapSecuritiesResponse>, I>>(object: I): HeatmapSecuritiesResponse {
    const message = createBaseHeatmapSecuritiesResponse();
    message.index = object.index ?? "";
    message.fields = object.fields?.map((e) => e) ?? [];
    message.securities = object.securities?.map((e) => ScanScreenerResponse_ScreenerSecurityData.fromPartial(e)) ?? [];
    message.groups = object.groups?.map((e) => HeatmapSecurityGroup.fromPartial(e)) ?? [];
    message.sizeByField = object.sizeByField ?? "";
    message.colorByField = object.colorByField ?? "";
    return message;
  },
};
